/* ==========================================================================
   Corporate Gifting - front-end interactions
   Loaded by every corporate-* section. Everything is progressive enhancement:
   filters, sorting, the gallery, the review filters and the star rating all
   degrade gracefully when JavaScript is unavailable.
   ========================================================================== */
(function () {
  'use strict';

  // Centralized URL sanitizer: strips contact_posted=true & #corp-quote anchors
  // while ALWAYS preserving ?view=corporate and other legitimate search parameters
  function sanitizeBrowserUrl() {
    if (typeof window === 'undefined' || !window.location || !window.history || !window.history.replaceState) return;
    try {
      var currentSearch = window.location.search || '';
      var currentHash = window.location.hash || '';

      var hasContactParam = currentSearch.indexOf('contact_posted=true') !== -1;
      var hasJdgmParam = currentSearch.indexOf('review_title=') !== -1 || currentSearch.indexOf('score=') !== -1;
      var hasQuoteHash = currentHash.indexOf('corp-quote') !== -1;

      if (!hasContactParam && !hasJdgmParam && !hasQuoteHash) {
        return;
      }

      var cleanedSearch = currentSearch
        .replace(/([?&])contact_posted=true(&|$)/g, function (m, p1, p2) {
          return (p1 === '?' && p2) ? '?' : '';
        })
        .replace(/([?&])(review_title|score)=[^&]*(&|$)/g, function (m, p1, p2, p3) {
          return (p1 === '?' && p3) ? '?' : '';
        })
        .replace(/[?&]$/, '');

      if (currentSearch.indexOf('view=corporate') !== -1 && cleanedSearch.indexOf('view=corporate') === -1) {
        cleanedSearch = cleanedSearch ? (cleanedSearch + '&view=corporate') : '?view=corporate';
      }

      var cleanedHash = hasQuoteHash ? '' : currentHash;
      var targetUrl = window.location.pathname + cleanedSearch + cleanedHash;

      if (targetUrl !== (window.location.pathname + currentSearch + currentHash)) {
        window.history.replaceState({}, document.title, targetUrl);
      }
    } catch (eClean) { }
  }

  // Sanitize browser address bar on load
  sanitizeBrowserUrl();
  if (false) { // legacy check removed
    var hasJdgmParam = window.location.search && (window.location.search.indexOf('review_title=') !== -1 || window.location.search.indexOf('score=') !== -1);
    var hasContactParam = window.location.search && window.location.search.indexOf('contact_posted=true') !== -1;
    var hasQuoteHash = window.location.hash && window.location.hash.indexOf('corp-quote') !== -1;
    if (hasJdgmParam || hasContactParam || hasQuoteHash) {
      try {
        var cleanSearch = window.location.search ? window.location.search.replace(/[?&]contact_posted=true(&|$)/, function (m, p) { return p === '&' ? '?' : ''; }).replace(/[?&](review_title|score)=[^&]*/g, '').replace(/\?$/, '') : '';
        var cleanUrl = window.location.pathname + (cleanSearch || (window.location.search && window.location.search.indexOf('view=corporate') !== -1 ? '?view=corporate' : ''));
        window.history.replaceState({}, document.title, cleanUrl);
      } catch (eClean) { }
    }
  }

  var onReady = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  var toNumber = function (value) {
    var n = parseFloat(value);
    return isNaN(n) ? 0 : n;
  };

  /* ----------------------------------------------------------------------
     Occasion collection grid: filters, sorting, facets and "show more"
     ---------------------------------------------------------------------- */

  function initCatalog(root) {
    var grid = root.querySelector('[data-corp-grid]');
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-corp-item]'));
    var inputs = Array.prototype.slice.call(root.querySelectorAll('input[data-corp-filter]'));
    var sortSelect = root.querySelector('[data-corp-sort]');
    var moreButton = root.querySelector('[data-corp-more]');
    var moreWrap = root.querySelector('[data-corp-more-wrap]') || (moreButton && moreButton.closest ? moreButton.closest('.corp-more') : null);
    var emptyState = root.querySelector('[data-corp-empty]');
    var countLabel = root.querySelector('[data-corp-count-label]');
    var activeWrap = root.querySelector('[data-corp-active-filters]');
    var clearButtons = Array.prototype.slice.call(root.querySelectorAll('[data-corp-clear]'));
    var clearButton = clearButtons[0] || null;
    var filterDrawer = root.querySelector('.corp-filters') || document.querySelector('.corp-filters');
    var filterBackdrop = root.querySelector('.corp-filters-backdrop') || document.querySelector('.corp-filters-backdrop');
    var openDrawerBtns = Array.prototype.slice.call(root.querySelectorAll('[data-corp-filter-open]'));
    var closeDrawerBtns = Array.prototype.slice.call(root.querySelectorAll('[data-corp-filter-close]'));
    var activeBadge = root.querySelector('[data-corp-active-count]');
    var mobileTotalCount = root.querySelector('[data-corp-mobile-total-count]');
    var initial = parseInt(grid.getAttribute('data-initial'), 10) || 6;
    var showAll = false;
    var visibleLimit = initial;
    var nextUrl = grid.getAttribute('data-next-url');
    var maxLimit = parseInt(grid.getAttribute('data-limit'), 10) || 60;
    var totalProducts = parseInt(grid.getAttribute('data-total'), 10) || items.length;
    var loadingMode = grid.getAttribute('data-loading-mode') || 'button';
    var isFetching = false;

    var fetchNextBatch = function (onComplete) {
      if (isFetching || !nextUrl || items.length >= maxLimit) {
        if (typeof onComplete === 'function') onComplete();
        return;
      }
      isFetching = true;
        if (moreButton) {
        moreButton.classList.add('is-loading');
        moreButton.setAttribute('disabled', 'disabled');
      }

      fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error('Network error');
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-corp-grid]');
          if (newGrid) {
            var newItems = Array.prototype.slice.call(newGrid.querySelectorAll('[data-corp-item]'));
            newItems.forEach(function (newItem) {
              if (items.length < maxLimit) {
                newItem.setAttribute('data-corp-index', String(items.length));
                grid.appendChild(newItem);
                items.push(newItem);
              }
            });

            nextUrl = newGrid.getAttribute('data-next-url');
            grid.setAttribute('data-next-url', nextUrl || '');

            initProductCards(grid);
            update();
          }
        })
        .catch(function (err) {
          console.warn('[Corporate Catalog] Error loading next page batch:', err);
        })
        .finally(function () {
          isFetching = false;
            if (moreButton) {
            moreButton.classList.remove('is-loading');
            moreButton.removeAttribute('disabled');
          }
          if (typeof onComplete === 'function') onComplete();
        });
    };

    items.forEach(function (item, index) {
      item.setAttribute('data-corp-index', String(index));
    });

    var readFilter = function (input) {
      return {
        input: input,
        group: input.getAttribute('data-group') || '',
        type: input.hasAttribute('data-min') || input.hasAttribute('data-max') ? 'budget' : 'tag',
        min: toNumber(input.getAttribute('data-min')),
        max: toNumber(input.getAttribute('data-max')),
        tag: (input.getAttribute('data-tag') || '').toLowerCase(),
        label: (input.parentNode.querySelector('span') || {}).textContent || ''
      };
    };

    var matches = function (item, filter) {
      if (filter.type === 'budget') {
        var price = toNumber(item.getAttribute('data-price'));
        return price >= filter.min && price <= filter.max;
      }
      var tags = (item.getAttribute('data-tags') || '').toLowerCase();
      if (!filter.tag) return true;
      var fTag = filter.tag.toLowerCase().trim();
      var fTagNoPrefix = fTag.replace(/^region:/, '').trim();
      var tagList = tags.split('|').map(function (t) { return t.trim(); });
      return tagList.indexOf(fTag) !== -1 || tagList.indexOf(fTagNoPrefix) !== -1 || tags.indexOf(fTagNoPrefix) !== -1;
    };

    var activeFilters = function () {
      return inputs.filter(function (input) {
        return input.checked;
      }).map(readFilter);
    };

    /* OR within the same facet group, AND across groups */
    var matchesGroups = function (item, filters) {
      if (!filters.length) return true;
      var groups = {};
      filters.forEach(function (filter) {
        var key = filter.group || filter.input.value;
        if (!groups[key]) groups[key] = [];
        groups[key].push(filter);
      });
      return Object.keys(groups).every(function (key) {
        return groups[key].some(function (filter) {
          return matches(item, filter);
        });
      });
    };

    var sortItems = function (list, mode) {
      var copy = list.slice();
      if (mode === 'price-asc' || mode === 'price-low') {
        copy.sort(function (a, b) {
          return toNumber(a.getAttribute('data-price')) - toNumber(b.getAttribute('data-price'));
        });
      } else if (mode === 'price-desc' || mode === 'price-high') {
        copy.sort(function (a, b) {
          return toNumber(b.getAttribute('data-price')) - toNumber(a.getAttribute('data-price'));
        });
      } else if (mode === 'title' || mode === 'name') {
        copy.sort(function (a, b) {
          return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
        });
      } else {
        copy.sort(function (a, b) {
          return toNumber(a.getAttribute('data-corp-index')) - toNumber(b.getAttribute('data-corp-index'));
        });
      }
      return copy;
    };

    var updateCounts = function (filters) {
      inputs.forEach(function (input) {
        var option = readFilter(input);
        var others = filters.filter(function (filter) {
          return filter.group !== option.group;
        });
        var count = items.filter(function (item) {
          return matchesGroups(item, others) && matches(item, option);
        }).length;
        var target = root.querySelector('[data-corp-count="' + input.value + '"]');
        if (!target && input.closest) {
          var label = input.closest('label');
          target = label ? label.querySelector('small') : null;
        }
        if (target) target.textContent = String(count);
      });
    };

    var renderChips = function (filters) {
      if (!activeWrap) return;
      activeWrap.innerHTML = '';
      filters.forEach(function (filter) {
        var chip = document.createElement('span');
        chip.className = 'corp-chip corp-chip--filter';
        chip.appendChild(document.createTextNode(filter.label.trim()));

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'corp-chip__remove';
        remove.setAttribute('aria-label', 'Remove filter');
        remove.textContent = '×';
        remove.addEventListener('click', function () {
          filter.input.checked = false;
          update();
        });

        chip.appendChild(remove);
        activeWrap.appendChild(chip);
      });
      clearButtons.forEach(function (btn) {
        if (btn.classList.contains('corp-clear')) {
          btn.hidden = filters.length === 0;
        } else {
          btn.disabled = filters.length === 0;
          btn.style.opacity = filters.length === 0 ? '0.5' : '1';
          btn.style.pointerEvents = filters.length === 0 ? 'none' : 'auto';
        }
      });
    };

    var update = function () {
      var filters = activeFilters();
      var matching = items.filter(function (item) {
        return matchesGroups(item, filters);
      });

      var ordered = sortItems(matching, sortSelect ? sortSelect.value : 'manual');
      showAll = (visibleLimit >= matching.length);
      /* UNWANTED_START
      // TEST_LINE
        showAll = true;
      } else {
        showAll = false;
      }

        if (visibleLimit < items.length) {
          visibleLimit += initial;
          update();
        } else if (nextUrl && items.length < maxLimit) {
          fetchNextBatch(function () {
            visibleLimit += initial;
            update();
          });
        }
// REMOVED
          visibleLimit += initial;
        }
      }
      UNWANTED_END */
      var visible = showAll ? ordered : ordered.slice(0, visibleLimit);

      items.forEach(function (item) {
        item.hidden = true;
      });
      ordered.forEach(function (item) {
        grid.appendChild(item);
      });
      visible.forEach(function (item) {
        item.hidden = false;
      });

      if (countLabel) {
        if (visible.length >= matching.length) {
          countLabel.textContent = matching.length + ' gifts';
        } else {
          countLabel.textContent = visible.length + ' of ' + matching.length + ' gifts';
        }
      }
      if (emptyState) emptyState.hidden = matching.length !== 0;
      if (activeBadge) {
        activeBadge.textContent = String(filters.length);
        activeBadge.hidden = filters.length === 0;
      }
      if (mobileTotalCount) {
        mobileTotalCount.textContent = matching.length + ' gifts';
      }
      var allLoaded = (showAll || visible.length >= matching.length) && (!nextUrl || items.length >= maxLimit);
        if (moreButton) {
        moreButton.hidden = allLoaded;
        moreButton.style.display = allLoaded ? 'none' : '';
      }
      if (moreWrap) {
        moreWrap.hidden = allLoaded;
        moreWrap.style.display = allLoaded ? 'none' : '';
      }
      clearButtons.forEach(function (btn) {
        if (btn.classList.contains('corp-clear')) {
          btn.hidden = filters.length === 0;
        } else {
          btn.disabled = filters.length === 0;
          btn.style.opacity = filters.length === 0 ? '0.5' : '1';
          btn.style.pointerEvents = filters.length === 0 ? 'none' : 'auto';
        }
      });

      updateCounts(filters);
      renderChips(filters);
    };

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        visibleLimit = initial;
        showAll = false;
        update();
      });
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        visibleLimit = initial;
        showAll = false;
        update();
      });
    }

      if (moreButton) {
      moreButton.addEventListener('click', function () {
        if (visibleLimit < items.length) {
          visibleLimit += initial;
          update();
        } else if (nextUrl && items.length < maxLimit) {
          fetchNextBatch(function () {
            visibleLimit += initial;
            update();
          });
        }
      });
    }

    if (loadingMode === 'infinite' && window.IntersectionObserver && moreWrap) {
      var infiniteObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !isFetching) {
            if (visibleLimit < items.length) {
              visibleLimit += initial;
              update();
            } else if (nextUrl && items.length < maxLimit) {
              fetchNextBatch(function () {
                visibleLimit += initial;
                update();
              });
            }
          }
        });
      }, { rootMargin: '300px' });
      infiniteObserver.observe(moreWrap);
    }

    if (nextUrl && items.length < maxLimit) {
      setTimeout(function () {
        fetchNextBatch(function () {
          if (loadingMode === 'all' && nextUrl && items.length < maxLimit) {
            fetchNextBatch();
          }
        });
      }, 150);
    }

    /* OLD_MORE_START
        if (visibleLimit < items.length) {
          visibleLimit += initial;
          update();
        } else if (nextUrl && items.length < maxLimit) {
          fetchNextBatch(function () {
            visibleLimit += initial;
            update();
          });
        }
// REMOVED
          visibleLimit += initial;
        }
        update();
      });
    }

    /* OLD_MORE_END */ for (var cbi = 0; cbi < clearButtons.length; cbi++) {
      var clearBtn = clearButtons[cbi];
      clearBtn.addEventListener('click', function () {
        visibleLimit = initial;
        inputs.forEach(function (input) {
          input.checked = false;
        });
        showAll = false;
        update();
      });
    }

    var openDrawer = function () {
      if (filterDrawer) filterDrawer.classList.add('is-open');
      if (filterBackdrop) filterBackdrop.classList.add('is-open');
      document.body.classList.add('corp-filters-open');
    };

    var closeDrawer = function () {
      if (filterDrawer) filterDrawer.classList.remove('is-open');
      if (filterBackdrop) filterBackdrop.classList.remove('is-open');
      document.body.classList.remove('corp-filters-open');
    };

    openDrawerBtns.forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });

    closeDrawerBtns.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    if (filterBackdrop) {
      filterBackdrop.addEventListener('click', closeDrawer);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && filterDrawer && filterDrawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // Budget & region pre-filtering via URL parameters (?corp_budget=min-max, ?region=name)
    var params = new URLSearchParams(window.location.search);
    var budgetParam = params.get('corp_budget') || params.get('budget');
    if (budgetParam) {
      var parts = budgetParam.split('-');
      var min = toNumber(parts[0]);
      var max = parts.length > 1 && !isNaN(parseFloat(parts[1])) ? toNumber(parts[1]) : Number.MAX_SAFE_INTEGER;
      inputs.forEach(function (input) {
        if (input.hasAttribute('data-min')) {
          var iMin = toNumber(input.getAttribute('data-min'));
          var iMax = toNumber(input.getAttribute('data-max'));
          if (iMin === min && (iMax === max || (max >= 99999 && iMax >= 99999))) {
            input.checked = true;
          }
        }
      });
    }

    var regionParam = params.get('region') || params.get('corp_region');
    if (regionParam) {
      var rClean = regionParam.toLowerCase().replace(/^region:/, '').trim();
      inputs.forEach(function (input) {
        var t = (input.getAttribute('data-tag') || '').toLowerCase().replace(/^region:/, '').trim();
        var val = (input.value || '').toLowerCase().replace(/^region-/, '').trim();
        if (t === rClean || val === rClean || val === 'region:' + rClean) {
          input.checked = true;
        }
      });
    }

    update();
  }

  /* ----------------------------------------------------------------------
     Product gallery
     ---------------------------------------------------------------------- */

  function initGallery(root) {
    var media = root.querySelector('[data-corp-media]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-corp-thumb]'));
    if (!media || !thumbs.length) return;

    var slides = Array.prototype.slice.call(media.querySelectorAll('img'));
    if (!slides.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.getAttribute('data-corp-thumb'), 10) || 0;
        thumbs.forEach(function (item) {
          item.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
        try {
          thumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        } catch (e) { }
        slides.forEach(function (slide, i) {
          if (i === index) slide.removeAttribute('hidden');
          else slide.setAttribute('hidden', 'hidden');
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
     Review filters
     ---------------------------------------------------------------------- */

  function initReviewFilters(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-corp-review-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-corp-review]'));
    if (!buttons.length || !cards.length) return;

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var filter = button.getAttribute('data-corp-review-filter');
        buttons.forEach(function (item) {
          item.classList.toggle('is-active', item === button);
        });
        cards.forEach(function (card) {
          var hideForPhotos = filter === 'photos' && card.getAttribute('data-has-photos') !== 'true';
          var hideForCorporate = filter === 'corporate' && card.getAttribute('data-corporate') !== 'true';
          var hide = hideForPhotos || hideForCorporate;
          card.hidden = hide;
          var slide = card.closest('[data-corp-slide]');
          if (slide) {
            slide.style.display = hide ? 'none' : '';
          }
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
     Star rating picker
     ---------------------------------------------------------------------- */

  function initRating(root) {
    var wrapper = root.querySelector('[data-corp-rating]');
    if (!wrapper) return;

    var inputs = Array.prototype.slice.call(wrapper.querySelectorAll('input[type="radio"]'));
    var stars = Array.prototype.slice.call(wrapper.querySelectorAll('.corp-star-btn'));
    var label = wrapper.querySelector('[data-corp-rating-label]');
    var words = { 1: 'Poor', 2: 'Fair', 3: 'Good', 4: 'Very good', 5: 'Excellent' };

    stars.forEach(function (star, index) {
      star.addEventListener('click', function () {
        stars.forEach(function (item, i) {
          item.classList.toggle('is-active', i <= index);
        });
        if (label) label.textContent = (index + 1) + ' of 5 · ' + words[index + 1];
      });
    });

    inputs.forEach(function (input, index) {
      if (input.checked) {
        stars.forEach(function (item, i) {
          item.classList.toggle('is-active', i <= index);
        });
        if (label) label.textContent = (index + 1) + ' of 5 · ' + words[index + 1];
      }
    });
  }

  /* ----------------------------------------------------------------------
     Review photo picker (previews + file name list, Shopify cannot store files)
     ---------------------------------------------------------------------- */

  function initPhotoPicker(root) {
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-corp-photo-input]'));
    inputs.forEach(function (input) {
      if (input.getAttribute('data-picker-bound') === 'true') return;
      input.setAttribute('data-picker-bound', 'true');

      var container = input.closest('fieldset') || input.closest('.corp-uploads') || input.parentElement;
      var previews = container.querySelector('[data-corp-photo-previews]');
      var fields = container.querySelector('[data-corp-photo-fields]');
      var error = container.querySelector('[data-corp-photo-error]');
      var fieldName = input.getAttribute('data-corp-photo-name') || 'contact[Photos]';
      var maxFiles = 5;
      var files = [];
      input._corpFiles = files;

      var updateDataTransfer = function () {
        input._corpFiles = files;
        try {
          var dt = new DataTransfer();
          files.forEach(function (f) { dt.items.add(f); });
          input.files = dt.files;
        } catch (e) { }
      };

      var render = function () {
        if (previews) previews.innerHTML = '';
        files.forEach(function (file, index) {
          if (!previews) return;
          var item = document.createElement('div');
          item.className = 'corp-uploads__preview';

          var img = document.createElement('img');
          img.alt = 'Selected photo ' + (index + 1);
          var url = URL.createObjectURL(file);
          img.src = url;
          img.addEventListener('load', function () {
            URL.revokeObjectURL(url);
          });

          var remove = document.createElement('button');
          remove.type = 'button';
          remove.setAttribute('aria-label', 'Remove photo ' + (index + 1));
          remove.innerHTML = '×';
          remove.addEventListener('click', function (e) {
            e.preventDefault();
            files.splice(index, 1);
            updateDataTransfer();
            render();
          });

          item.appendChild(img);
          item.appendChild(remove);
          previews.appendChild(item);
        });

        if (fields) {
          fields.innerHTML = '';
          if (files.length) {
            var hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = fieldName;
            hidden.value = files.map(function (f) { return f.name; }).join(', ');
            fields.appendChild(hidden);
          }
        }
      };

      input.addEventListener('change', function () {
        var incoming = Array.prototype.slice.call(input.files || []);
        var valid = incoming.filter(function (file) {
          return file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/webp' || /\.(jpe?g|png|webp)$/i.test(file.name);
        });
        var message = '';

        if (valid.length !== incoming.length) message = 'Only JPG, PNG or WebP images can be added.';
        if (files.length + valid.length > maxFiles) message = 'You can add up to ' + maxFiles + ' photos.';

        files = files.concat(valid).slice(0, maxFiles);
        updateDataTransfer();
        if (error) error.textContent = message;
        render();
      });
    });
  }

  /* ----------------------------------------------------------------------
     Quote form: add another product row
     ---------------------------------------------------------------------- */

  function initQuoteExtras(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-corp-add-product]'));

    buttons.forEach(function (button) {
      var targetId = button.getAttribute('data-target');
      var target = targetId ? document.getElementById(targetId) : null;
      if (!target) return;

      button.addEventListener('click', function () {
        var index = target.querySelectorAll('.corp-extra-item').length + 2;

        var row = document.createElement('div');
        row.className = 'corp-extra-item';

        var input = document.createElement('input');
        input.type = 'text';
        input.name = 'contact[Extra product ' + index + ']';
        input.placeholder = 'Product name or link';
        input.setAttribute('aria-label', 'Additional product ' + index);
        input.style.cssText = 'flex:1;min-width:0;border:1px solid var(--c-border);border-radius:6px;padding:8px 10px;background:#fff;font-size:12px;';

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = 'Remove ×';
        remove.setAttribute('aria-label', 'Remove product ' + index);
        remove.addEventListener('click', function () {
          row.remove();
        });

        row.appendChild(input);
        row.appendChild(remove);
        target.appendChild(row);
        input.focus();
      });
    });
  }

  /* ----------------------------------------------------------------------
     Dynamic product pre-population (?product=handle) for quote and review forms
     ---------------------------------------------------------------------- */

  function initProductParam(root) {
    var params = new URLSearchParams(window.location.search);
    var productHandle = params.get('product');
    if (!productHandle) return;

    var summaryWrap = root.querySelector('.corp-summary');
    var bannerWrap = root.querySelector('[data-corp-selected-product]');
    var bannerTitle = root.querySelector('[data-corp-selected-title]');
    var reviewHead = root.querySelector('.corp-review-page__head');
    var productInput = root.querySelector('input[name="contact[Product]"], [data-corp-product-input]');
    var jdgmWidget = root.querySelector('#judgeme_product_reviews.jdgm-widget');

    if (!summaryWrap && !bannerWrap && !reviewHead && !productInput && !jdgmWidget) return;

    fetch('/products/' + encodeURIComponent(productHandle) + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product fetch failed');
        return res.json();
      })
      .then(function (prod) {
        if (!prod || !prod.title) return;

        // Quote form summary (card layout)
        if (summaryWrap) {
          summaryWrap.hidden = false;
          summaryWrap.removeAttribute('hidden');
          summaryWrap.style.display = 'flex';
          var titleEl = summaryWrap.querySelector('strong');
          var thumbImg = summaryWrap.querySelector('.corp-summary__thumb img');
          var priceEl = summaryWrap.querySelector('span');
          if (titleEl) titleEl.textContent = prod.title;
          if (thumbImg && prod.featured_image) {
            thumbImg.src = prod.featured_image;
            thumbImg.alt = prod.title;
            thumbImg.style.display = '';
          }
          if (priceEl && prod.price) {
            var formattedPrice = '₹' + (prod.price / 100).toLocaleString('en-IN');
            var skuPart = prod.variants && prod.variants[0] && prod.variants[0].sku ? 'SKU ' + prod.variants[0].sku + ' · ' : '';
            priceEl.textContent = skuPart + 'from ' + formattedPrice + ' / unit';
          }
        }

        // Selected product banner (split layout)
        if (bannerWrap) {
          if (bannerTitle) bannerTitle.textContent = prod.title;
          bannerWrap.hidden = false;
          bannerWrap.removeAttribute('hidden');
          bannerWrap.style.display = 'flex';
        }

        // Review form header
        if (reviewHead) {
          var subEl = reviewHead.querySelector('p');
          var thumbWrap = reviewHead.querySelector('.corp-summary__thumb');
          var revThumb = reviewHead.querySelector('.corp-summary__thumb img');
          if (subEl) subEl.textContent = prod.title;
          if (thumbWrap && prod.featured_image) {
            thumbWrap.style.display = '';
            if (revThumb) {
              revThumb.src = prod.featured_image;
              revThumb.alt = prod.title;
              revThumb.style.display = '';
            }
          }
        }

        // Judge.me live widget binding for review page
        if (jdgmWidget && prod.id) {
          jdgmWidget.setAttribute('data-id', prod.id);
          jdgmWidget.setAttribute('data-product-title', prod.title);

          var triggerJdgm = function () {
            if (window.jdgm && typeof window.jdgm.loadWidgets === 'function') {
              window.jdgm.loadWidgets();
              return true;
            } else if (window.jdgm && typeof window.jdgm.init === 'function') {
              window.jdgm.init();
              return true;
            }
            return false;
          };

          if (!triggerJdgm()) {
            var attempts = 0;
            var poll = setInterval(function () {
              attempts++;
              if (triggerJdgm() || attempts > 20) {
                clearInterval(poll);
              }
            }, 250);
          }

          if (jdgmWidget.getAttribute('data-auto-open') === 'true') {
            var openAttempts = 0;
            var openInterval = setInterval(function () {
              openAttempts++;
              var writeBtn = jdgmWidget.querySelector('.jdgm-write-rev-link');
              var formWrapper = jdgmWidget.querySelector('.jdgm-form-wrapper');
              if (writeBtn && (!formWrapper || formWrapper.style.display === 'none')) {
                writeBtn.click();
                clearInterval(openInterval);
              } else if (formWrapper && formWrapper.style.display !== 'none') {
                clearInterval(openInterval);
              }
              if (openAttempts > 30) clearInterval(openInterval);
            }, 300);
          }
        }

        // Hidden inputs
        if (productInput) {
          productInput.value = prod.title;
          if (prod.id) productInput.setAttribute('data-product-id', String(prod.id));
        } else {
          var form = root.querySelector('form');
          if (form) {
            var hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'contact[Product]';
            hidden.value = prod.title;
            if (prod.id) hidden.setAttribute('data-product-id', String(prod.id));
            form.appendChild(hidden);
          }
        }
        var skuInput = root.querySelector('input[name="contact[Product SKU]"], [data-corp-product-sku]');
        if (skuInput && prod.variants && prod.variants[0] && prod.variants[0].sku) {
          skuInput.value = prod.variants[0].sku;
        }
        var urlInput = root.querySelector('input[name="contact[Product URL]"], [data-corp-product-url]');
        if (urlInput && prod.url) {
          urlInput.value = window.location.origin + prod.url;
        }
      })
      .catch(function () {
        var fallbackTitle = productHandle.replace(/-/g, ' ').replace(/\b\w/g, function (l) { return l.toUpperCase(); });
        if (productInput) productInput.value = fallbackTitle;
        if (summaryWrap) {
          summaryWrap.hidden = false;
          summaryWrap.removeAttribute('hidden');
          summaryWrap.style.display = 'flex';
          var titleEl = summaryWrap.querySelector('strong');
          if (titleEl) titleEl.textContent = fallbackTitle;
        }
      });
  }

  /* ----------------------------------------------------------------------
     Featured products automatic slider ("Popular with corporate buyers")
     ---------------------------------------------------------------------- */

  function initFeaturedSlider(root) {
    var sliders = Array.prototype.slice.call(root.querySelectorAll('[data-corp-slider]'));
    if (root.hasAttribute && root.hasAttribute('data-corp-slider')) {
      sliders.push(root);
    }
    if (!sliders.length) return;

    sliders.forEach(function (slider) {
      if (slider.getAttribute('data-slider-ready') === 'true') return;

      var track = slider.querySelector('[data-corp-slider-track]');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-corp-slide]'));
      if (slides.length <= 1) return;

      var container = slider.closest('.corp-featured') || slider.closest('.corp-related') || slider.closest('.corp-review-slider-wrap') || slider.parentElement;
      var prevBtn = slider.querySelector('[data-corp-slider-prev]') || (container ? container.querySelector('[data-corp-slider-prev]') : null);
      var nextBtn = slider.querySelector('[data-corp-slider-next]') || (container ? container.querySelector('[data-corp-slider-next]') : null);
      var arrowsWrap = slider.querySelector('[data-corp-slider-arrows]') || (container ? container.querySelector('[data-corp-slider-arrows]') : null);
      var dotsWrap = slider.querySelector('[data-corp-slider-dots]');

      var isAutoplay = slider.getAttribute('data-autoplay') !== 'false';
      var speedAttr = parseInt(slider.getAttribute('data-autoplay-speed'), 10);
      var autoplaySpeed = isNaN(speedAttr) || speedAttr < 1500 ? 4000 : speedAttr;

      var getStep = function () {
        if (!slides[0]) return 0;
        var slideWidth = slides[0].getBoundingClientRect().width;
        var gap = 18;
        try {
          var compGap = window.getComputedStyle(track).gap;
          if (compGap && compGap !== 'normal') {
            gap = parseFloat(compGap) || 18;
          }
        } catch (e) { }
        return slideWidth + gap;
      };

      var scrollNext = function () {
        var step = getStep();
        if (!step) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= maxScroll - 15) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: step, behavior: 'smooth' });
        }
      };

      var scrollPrev = function () {
        var step = getStep();
        if (!step) return;
        if (track.scrollLeft <= 15) {
          track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -step, behavior: 'smooth' });
        }
      };

      var buildDots = function () {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        var step = getStep();
        if (!step) return;
        var visibleCount = Math.max(1, Math.round(track.clientWidth / step));
        var pages = Math.ceil(slides.length / visibleCount);
        if (pages <= 1) {
          dotsWrap.style.display = 'none';
          return;
        }
        dotsWrap.style.display = 'flex';
        for (var i = 0; i < pages; i++) {
          (function (pageIndex) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'corp-slider-dot' + (pageIndex === 0 ? ' is-active' : '');
            dot.setAttribute('role', 'tab');
            dot.setAttribute('aria-label', 'Go to slide group ' + (pageIndex + 1));
            dot.setAttribute('aria-selected', pageIndex === 0 ? 'true' : 'false');
            dot.addEventListener('click', function () {
              resetAutoplay();
              var target = Math.min(pageIndex * visibleCount * step, track.scrollWidth - track.clientWidth);
              track.scrollTo({ left: target, behavior: 'smooth' });
            });
            dotsWrap.appendChild(dot);
          })(i);
        }
      };

      var updateActiveDot = function () {
        if (!dotsWrap) return;
        var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.corp-slider-dot'));
        if (!dots.length) return;
        var step = getStep();
        if (!step) return;
        var visibleCount = Math.max(1, Math.round(track.clientWidth / step));
        var pageSize = visibleCount * step;
        var pageIndex = Math.round(track.scrollLeft / pageSize);
        if (pageIndex >= dots.length) pageIndex = dots.length - 1;
        if (pageIndex < 0) pageIndex = 0;
        dots.forEach(function (dot, idx) {
          if (idx === pageIndex) {
            dot.classList.add('is-active');
            dot.setAttribute('aria-selected', 'true');
          } else {
            dot.classList.remove('is-active');
            dot.setAttribute('aria-selected', 'false');
          }
        });
      };

      var timer = null;
      var isPaused = false;

      var startAutoplay = function () {
        if (!isAutoplay || timer) return;
        timer = setInterval(function () {
          if (!isPaused && document.visibilityState !== 'hidden') {
            scrollNext();
          }
        }, autoplaySpeed);
      };

      var stopAutoplay = function () {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };

      var resetAutoplay = function () {
        stopAutoplay();
        startAutoplay();
      };

      if (!slider._corpEventsBound) {
        slider._corpEventsBound = true;
        slider.addEventListener('mouseenter', function () { isPaused = true; });
        slider.addEventListener('mouseleave', function () { isPaused = false; });
        slider.addEventListener('focusin', function () { isPaused = true; });
        slider.addEventListener('focusout', function () { isPaused = false; });

        if (arrowsWrap) {
          arrowsWrap.addEventListener('mouseenter', function () { isPaused = true; });
          arrowsWrap.addEventListener('mouseleave', function () { isPaused = false; });
        }

        track.addEventListener('touchstart', function () { isPaused = true; }, { passive: true });
        track.addEventListener('touchend', function () {
          isPaused = false;
          resetAutoplay();
        }, { passive: true });

        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            resetAutoplay();
            scrollPrev();
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            resetAutoplay();
            scrollNext();
          });
        }

        var scrollDebounce = null;
        track.addEventListener('scroll', function () {
          if (scrollDebounce) cancelAnimationFrame(scrollDebounce);
          scrollDebounce = requestAnimationFrame(updateActiveDot);
        }, { passive: true });

        var resizeTimeout = null;
        window.addEventListener('resize', function () {
          if (resizeTimeout) clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(function () {
            if (false) {
            }
            buildDots();
            updateActiveDot();
          }, 150);
        });

      }
      buildDots();
      startAutoplay();
      slider.setAttribute('data-slider-ready', 'true');
    });
  }

  /* ----------------------------------------------------------------------
     Judge.me Reviews Integration:
     - Smooth scroll to #corporate-reviews when clicking PDP star rating
     - Auto-opens review form on review page when data-auto-open="true"
     ---------------------------------------------------------------------- */

  function initJudgeMe(root) {
    // Smooth scroll for PDP rating badge
    var ratingLinks = Array.prototype.slice.call(root.querySelectorAll('a.corp-rating[href^="#"]'));
    ratingLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var hash = link.getAttribute('href');
        if (!hash || hash.length < 2) return;
        var target = document.querySelector(hash);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // Auto-open review form on dedicated review page when data-auto-open is set
    var autoOpenWidget = root.querySelector('[data-corp-review-judgeme] #judgeme_product_reviews[data-auto-open="true"]');
    if (autoOpenWidget) {
      var openAttempts = 0;
      var openInterval = setInterval(function () {
        openAttempts++;
        var formWrapper = autoOpenWidget.querySelector('.jdgm-form-wrapper');
        var writeBtn = autoOpenWidget.querySelector('.jdgm-write-rev-link');
        if (writeBtn && (!formWrapper || formWrapper.style.display === 'none')) {
          writeBtn.click();
          clearInterval(openInterval);
        } else if (formWrapper && formWrapper.style.display !== 'none') {
          clearInterval(openInterval);
        }
        if (openAttempts > 30) clearInterval(openInterval);
      }, 250);
    }
  }

  /* ----------------------------------------------------------------------
     Judge.me Helpers & Review Card Builder
     ---------------------------------------------------------------------- */

  function getJudgeMeToken() {
    if (window._corpProductInfo && (window._corpProductInfo.jdgmPrivateToken || window._corpProductInfo.jdgmToken)) { return window._corpProductInfo.jdgmPrivateToken || window._corpProductInfo.jdgmToken;

    }
    if (window.jdgmSettings && window.jdgmSettings.api_token) {
      return window.jdgmSettings.api_token;
    }
    if (window.jdgm && window.jdgm.api_token) {
      return window.jdgm.api_token;
    }
    var tokenScript = document.querySelector('script[data-api-token], script[data-token]');
    if (tokenScript) {
      return tokenScript.getAttribute('data-api-token') || tokenScript.getAttribute('data-token') || '';
    }
    try {
      for (var s = 0; s < document.scripts.length; s++) {
        var sc = document.scripts[s];
        if (sc.src && sc.src.indexOf('judge.me') !== -1 && sc.src.indexOf('api_token=') !== -1) {
          var m = sc.src.match(/api_token=([^&]+)/);
          if (m && m[1]) return decodeURIComponent(m[1]);
        }
      }
    } catch (e) { }
    return '';
  }

  // Canonical review signature generator ensuring exact deduplication
  function getReviewSig(title, body, name) {
    var cTitle = String(title || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    var cBody = String(body || '').toLowerCase().replace(/\[corporate:[^\]]*\]/gi, '').replace(/[^a-z0-9]/g, '');
    var cName = String(name || '').toLowerCase().split('-')[0].split('·')[0].replace(/[^a-z0-9]/g, '');
    return cTitle + '|' + cBody.slice(0, 60) + '|' + cName;
  }

  // Helpers to manage locally submitted reviews so they survive page refreshes
  function normalizeReviewHandle(value) {
    return String(value || '').trim().toLowerCase().replace(/[^a-z0-9-_]/g, '').slice(0, 120);
  }

  function getReviewStorageKeys(prodId, prodHandle) {
    var keys = [];
    var pId = String(prodId || '').trim();
    var handle = normalizeReviewHandle(prodHandle);

    if (pId) keys.push('corp_user_reviews_' + pId);
    if (handle) keys.push('corp_user_reviews_handle_' + handle);
    if (!keys.length) keys.push('corp_user_reviews_anon');
    return keys.filter(function (key, idx, arr) { return arr.indexOf(key) === idx; });
  }

  function getLocalReviews(prodId, prodHandle) {
    try {
      var keys = getReviewStorageKeys(prodId, prodHandle);
      var merged = [];
      var seen = {};

      keys.forEach(function (key) {
        var raw = localStorage.getItem(key);
        if (!raw) return;
        try {
          var arr = JSON.parse(raw);
          if (!Array.isArray(arr)) return;
          arr.forEach(function (r) {
            var sig = getReviewSig(r.title, r.body, r.author || r.name);
            if (!seen[sig]) {
              seen[sig] = true;
              merged.push(r);
            }
          });
        } catch (e) { }
      });

      return merged;
    } catch (e) {
      return [];
    }
  }

  function saveLocalReview(prodId, prodHandle, revData) {
    try {
      var keys = getReviewStorageKeys(prodId, prodHandle);
      var list = [];
      keys.forEach(function (key) {
        var raw = localStorage.getItem(key);
        if (raw) {
          try {
            var arr = JSON.parse(raw);
            if (Array.isArray(arr)) list = list.concat(arr);
          } catch (e) { }
        }
      });

      list.unshift(revData);
      var unique = [];
      var seen = {};
      list.forEach(function (r) {
        var sig = getReviewSig(r.title, r.body, r.author || r.name);
        if (!seen[sig]) {
          seen[sig] = true;
          unique.push(r);
        }
      });

      keys.forEach(function (key) {
        localStorage.setItem(key, JSON.stringify(unique.slice(0, 10)));
      });
    } catch (e) { }
  }

  function buildReviewCardDOM(revData, isJustAdded) {
    var score = Math.max(1, Math.min(5, Math.round(Number(revData.rating) || 5)));
    var starStr = '';
    for (var s = 1; s <= 5; s++) starStr += (s <= score ? '★' : '☆');

    var slide = document.createElement('div');
    slide.className = 'corp-review-slide';
    slide.setAttribute('data-corp-slide', '');

    var article = document.createElement('article');
    article.className = 'corp-review-card' + (isJustAdded ? ' corp-review-card--just-added' : '');
    article.setAttribute('data-corp-review', '');
    article.setAttribute('data-has-photos', (revData.photos && revData.photos.length) ? 'true' : 'false');
    article.setAttribute('data-corporate', 'true');

    var topDiv = document.createElement('div');
    topDiv.className = 'corp-review-card__top';
    var starsSpan = document.createElement('span');
    starsSpan.className = 'corp-stars';
    starsSpan.setAttribute('aria-hidden', 'true');
    starsSpan.textContent = starStr;
    var dateEl = document.createElement('time');
    dateEl.textContent = revData.date || 'Recent order';
    topDiv.appendChild(starsSpan);
    topDiv.appendChild(dateEl);

    var h3 = document.createElement('h3');
    h3.textContent = revData.title || (revData.body ? (revData.body.length > 50 ? revData.body.slice(0, 47) + '...' : revData.body) : 'Verified Purchase');

    var p = document.createElement('p');
    p.textContent = revData.body || '';

    article.appendChild(topDiv);
    article.appendChild(h3);
    article.appendChild(p);

    if (revData.photos && revData.photos.length) {
      var thumbs = document.createElement('div');
      thumbs.className = 'corp-review-card__thumbs';
      revData.photos.slice(0, 2).forEach(function (photoSrc) {
        if (!photoSrc) return;
        var span = document.createElement('span');
        span.className = 'corp-media';
        var img = document.createElement('img');
        img.src = photoSrc;
        img.alt = revData.title || 'Customer photo';
        img.loading = 'lazy';
        span.appendChild(img);
        thumbs.appendChild(span);
      });
      article.appendChild(thumbs);
    }

    var authorP = document.createElement('p');
    authorP.className = 'corp-review-card__author';
    var nameSpan = document.createElement('span');
    nameSpan.className = 'corp-review-card__author-name';
    var rawAuthor = (revData.author || revData.name || 'Corporate Buyer').trim();
    var cleanAuthor = rawAuthor;
    var cardCompany = (revData.company || '').trim();
    if (rawAuthor.indexOf(' - ') !== -1) {
      var nParts = rawAuthor.split(' - ');
      cleanAuthor = nParts[0].trim();
      if (!cardCompany) cardCompany = nParts.slice(1).join(' - ').trim();
    } else if (rawAuthor.indexOf(' · ') !== -1) {
      var nParts = rawAuthor.split(' · ');
      cleanAuthor = nParts[0].trim();
      if (!cardCompany) cardCompany = nParts.slice(1).join(' · ').trim();
    }
    nameSpan.textContent = cleanAuthor;
    authorP.appendChild(nameSpan);
    if (cardCompany) {
      authorP.appendChild(document.createTextNode(', '));
      var companySpan = document.createElement('span');
      companySpan.className = 'corp-review-card__company';
      companySpan.textContent = cardCompany;
      authorP.appendChild(companySpan);
    }
    authorP.appendChild(document.createTextNode(' · '));
    var orderTag = document.createElement('strong');
    orderTag.className = 'corp-order-tag';
    orderTag.textContent = 'Corporate order';
    authorP.appendChild(orderTag);
    if (revData.verified !== false) {
      authorP.appendChild(document.createTextNode(' · '));
      var verifiedSpan = document.createElement('span');
      verifiedSpan.className = 'corp-verified-check';
      verifiedSpan.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg> <span>' + (revData.verifiedLabel || 'Verified buyer') + '</span>';
      authorP.appendChild(verifiedSpan);
    }
    article.appendChild(authorP);

    slide.appendChild(article);
    return slide;
  }

  /* ----------------------------------------------------------------------
     Popup Modals (Review & Quote Modals)
     ---------------------------------------------------------------------- */

  function cleanPriceText(str) {
    if (!str) return '';
    var cleaned = String(str)
      .replace(/<[^>]*>/g, '')
      .replace(/&lt;[^&]*&gt;/gi, '')
      .replace(/&lt;[\s\S]*?&gt;/gi, '')
      .replace(/<\/?span[^>]*>/gi, '')
      .replace(/class=['"]?money['"]?/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
    var match = cleaned.match(/(?:₹|Rs\.?|INR)\s*[\d,]+(?:\.\d+)?/i);
    if (match) return match[0].trim();
    var numMatch = cleaned.match(/[\d,]+(?:\.\d+)?/);
    if (numMatch) return '₹' + numMatch[0].trim();
    return cleaned;
  }

  function initModals(root) {
    // Deduplicate modals if rendered in multiple sections
    var allQModals = document.querySelectorAll('#corp-quote-modal');
    if (allQModals.length > 1) {
      for (var qm = 1; qm < allQModals.length; qm++) allQModals[qm].remove();
    }
    var allQBackdrops = document.querySelectorAll('#corp-quote-backdrop');
    if (allQBackdrops.length > 1) {
      for (var qb = 1; qb < allQBackdrops.length; qb++) allQBackdrops[qb].remove();
    }
    var allRModals = document.querySelectorAll('#corp-review-modal');
    if (allRModals.length > 1) {
      for (var rm = 1; rm < allRModals.length; rm++) allRModals[rm].remove();
    }
    var allRBackdrops = document.querySelectorAll('#corp-review-backdrop');
    if (allRBackdrops.length > 1) {
      for (var rb = 1; rb < allRBackdrops.length; rb++) allRBackdrops[rb].remove();
    }

    var reviewModal = document.getElementById('corp-review-modal');
    var reviewBackdrop = document.getElementById('corp-review-backdrop');
    var quoteModal = document.getElementById('corp-quote-modal');
    var quoteBackdrop = document.getElementById('corp-quote-backdrop');

    function resetQuoteModalState(modal) {
      if (!modal) return;
      var fieldsWrap = modal.querySelector('[data-corp-modal-fields]');
      if (fieldsWrap) fieldsWrap.style.display = '';
      var successMsg = modal.querySelector('[data-corp-modal-success]');
      if (successMsg) successMsg.style.display = 'none';
      var errorMsg = modal.querySelector('[data-corp-modal-error]');
      if (errorMsg) {
        errorMsg.textContent = '';
        errorMsg.style.display = 'none';
      }
      var submitBtn = modal.querySelector('[data-corp-modal-submit]');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.style.display = '';
        var origLabel = submitBtn.getAttribute('data-original-label');
        if (origLabel) submitBtn.textContent = origLabel;
      }
      var hp = modal.querySelector('input[name="corp_hp_url"]');
      if (hp) hp.value = '';
    }

    var openModal = function (modal, backdrop) {
      if (!modal) return;
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      modal.style.display = 'flex';
      if (backdrop) {
        backdrop.classList.add('is-active');
        backdrop.setAttribute('aria-hidden', 'false');
        backdrop.style.display = 'block';
      }
      document.body.classList.add('corp-modal-open');
    };

    var closeModal = function (modal, backdrop) {
      if (modal) {
        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');
        setTimeout(function () {
          if (!modal.classList.contains('is-active')) {
            modal.style.display = 'none';
          }
        }, 250);
      }
      if (backdrop) {
        backdrop.classList.remove('is-active');
        backdrop.setAttribute('aria-hidden', 'true');
        setTimeout(function () {
          if (!backdrop.classList.contains('is-active')) {
            backdrop.style.display = 'none';
          }
        }, 250);
      }
      document.body.classList.remove('corp-modal-open');
    };

    var closeAllModals = function () {
      closeModal(reviewModal, reviewBackdrop);
      closeModal(quoteModal, quoteBackdrop);
      var jdgmHost = document.querySelector('[data-corp-jdgm-bridge-wrap].is-open');
      if (jdgmHost) {
        jdgmHost.classList.remove('is-open');
        jdgmHost.setAttribute('inert', '');
        jdgmHost.setAttribute('aria-hidden', 'true');
      }
    };

    // Review modal trigger ("Write a review") -> Opens bespoke corporate review modal
    var reviewTriggers = Array.prototype.slice.call(root.querySelectorAll('[data-corp-review-trigger]'));
    reviewTriggers.forEach(function (trigger) {
      if (trigger.getAttribute('data-modal-bound') === 'true') return;
      trigger.setAttribute('data-modal-bound', 'true');
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!reviewModal) reviewModal = document.getElementById('corp-review-modal');
        if (!reviewBackdrop) reviewBackdrop = document.getElementById('corp-review-backdrop');

        if (!reviewModal) {
          var fallbackHref = trigger.getAttribute('href');
          if (fallbackHref && fallbackHref !== '#') {
            window.location.href = fallbackHref;
          }
          return;
        }

        // Reset form fields if already submitted
        var form = reviewModal.querySelector('form');
        if (form) {
          var fieldsWrap = form.querySelector('[data-corp-modal-fields]');
          var successMsg = form.querySelector('[data-corp-modal-success]');
          var submitBtn = form.querySelector('[data-corp-modal-submit]');
          if (fieldsWrap) fieldsWrap.style.display = '';
          if (successMsg) successMsg.style.display = 'none';
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Submit review';
            submitBtn.style.display = '';
          }
        }

        ensureJdgmForm();
        openModal(reviewModal, reviewBackdrop);
      });
    });

    // Quote modal triggers ("Get a quote" buttons across PDP & cards)
    var quoteTriggers = Array.prototype.slice.call(root.querySelectorAll('[data-corp-quote-btn], [data-corp-quote-trigger]'));
    quoteTriggers.forEach(function (trigger) {
      if (trigger.getAttribute('data-modal-bound') === 'true') return;
      trigger.setAttribute('data-modal-bound', 'true');
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!quoteModal) quoteModal = document.getElementById('corp-quote-modal');
        if (!quoteBackdrop) quoteBackdrop = document.getElementById('corp-quote-backdrop');
        if (!quoteModal) return;

        var pUrl = trigger.getAttribute('data-product-url');
        if (pUrl) {
          var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
          var fullUrl = /^https?:\/\//i.test(pUrl) ? pUrl : (rootUrl.replace(/\/$/, '') + '/' + pUrl.replace(/^\//, ''));
          var inUrl = quoteModal.querySelector('[data-corp-quote-input-url]');
          if (inUrl) inUrl.value = fullUrl;
        }

        var pTitle = trigger.getAttribute('data-product-title');
        var pSku = trigger.getAttribute('data-product-sku');
        var pPrice = trigger.getAttribute('data-product-price');
        var pImage = trigger.getAttribute('data-product-image');

        if (pTitle) {
          pTitle = pTitle.replace(/<[^>]*>/g, '').replace(/&lt;[^&]*&gt;/gi, '').trim();
          var titleEl = quoteModal.querySelector('[data-corp-quote-title]');
          if (titleEl) titleEl.textContent = pTitle;
          var inProd = quoteModal.querySelector('[data-corp-quote-input-product]');
          if (inProd) inProd.value = pTitle;
        }
        if (pSku) {
          pSku = pSku.replace(/<[^>]*>/g, '').replace(/&lt;[^&]*&gt;/gi, '').trim();
          var inSku = quoteModal.querySelector('[data-corp-quote-input-sku]');
          if (inSku) inSku.value = pSku;
        }
        if (pPrice) {
          pPrice = cleanPriceText(pPrice);
        }
        if (pPrice || pSku) {
          var metaEl = quoteModal.querySelector('[data-corp-quote-meta]');
          if (metaEl) {
            var metaText = '';
            if (pSku) metaText += 'SKU ' + pSku + ' · ';
            if (pPrice) metaText += 'from ' + pPrice + ' / unit';
            metaEl.textContent = metaText;
          }
        }
        if (pImage) {
          var thumb = quoteModal.querySelector('[data-corp-quote-thumb]');
          var wrap = quoteModal.querySelector('[data-corp-quote-thumb-wrap]');
          if (thumb) {
            thumb.src = pImage;
            thumb.style.display = '';
          }
          if (wrap) wrap.style.display = '';
        }

        // Sync entered quantity from PDP input if present
        var qtyInput = document.querySelector('[data-corp-pdp-qty]');
        if (qtyInput && qtyInput.value) {
          var modalQty = quoteModal.querySelector('input[name="contact[Quantity]"]');
          if (modalQty) modalQty.value = qtyInput.value;
          var activeTierRow = document.querySelector('.corp-tier__row.is-highlight');
          if (activeTierRow) {
            var activePrice = activeTierRow.getAttribute('data-tier-price') || (activeTierRow.querySelector('[data-corp-tier-price]') ? activeTierRow.querySelector('[data-corp-tier-price]').textContent.trim() : '');
            if (activePrice) {
              var metaEl = quoteModal.querySelector('[data-corp-quote-meta]');
              if (metaEl) {
                var metaText = '';
                if (pSku) metaText += 'SKU ' + pSku + ' · ';
                metaText += 'from ' + activePrice + ' / unit';
                metaEl.textContent = metaText;
              }
            }
          }
        }

        var modalBoxes = Array.prototype.slice.call(quoteModal.querySelectorAll('input[type="checkbox"][name*="Branding"]'));
        modalBoxes.forEach(function (mb) { mb.checked = false; });
        // Sync selected branding options from PDP chips if checked
        var checkedBranding = Array.prototype.slice.call(document.querySelectorAll('[data-corp-branding-item]:checked'));
        if (checkedBranding.length) {
          checkedBranding.forEach(function (chk) {
            var val = (chk.getAttribute('data-corp-branding-item') || '').toLowerCase();
            var modalBoxes = Array.prototype.slice.call(quoteModal.querySelectorAll('input[type="checkbox"][name*="Branding"]'));
            modalBoxes.forEach(function (mb) {
              var mbName = (mb.name || '').toLowerCase();
              if (val && mbName.indexOf(val) !== -1) {
                mb.checked = true;
              }
            });
          });
        }

        resetQuoteModalState(quoteModal);
        openModal(quoteModal, quoteBackdrop);
      });
    });

    // Delegated click handler for dynamically loaded/filtered cards
    if (!window.corpQuoteDelegatedBound) {
      window.corpQuoteDelegatedBound = true;
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-corp-quote-btn], [data-corp-quote-trigger]');
        if (!trigger) return;
        e.preventDefault();
        e.stopPropagation();
        var qModal = document.getElementById('corp-quote-modal');
        var qBackdrop = document.getElementById('corp-quote-backdrop');
        if (!qModal) return;

        var pUrl = trigger.getAttribute('data-product-url');
        if (pUrl) {
          var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
          var fullUrl = /^https?:\/\//i.test(pUrl) ? pUrl : (rootUrl.replace(/\/$/, '') + '/' + pUrl.replace(/^\//, ''));
          var inUrl = qModal.querySelector('[data-corp-quote-input-url]');
          if (inUrl) inUrl.value = fullUrl;
        }

        var pTitle = trigger.getAttribute('data-product-title');
        var pSku = trigger.getAttribute('data-product-sku');
        var pPrice = trigger.getAttribute('data-product-price');
        var pImage = trigger.getAttribute('data-product-image');

        if (pTitle) {
          pTitle = pTitle.replace(/<[^>]*>/g, '').replace(/&lt;[^&]*&gt;/gi, '').trim();
          var titleEl = qModal.querySelector('[data-corp-quote-title]');
          if (titleEl) titleEl.textContent = pTitle;
          var inProd = qModal.querySelector('[data-corp-quote-input-product]');
          if (inProd) inProd.value = pTitle;
        }
        if (pSku) {
          pSku = pSku.replace(/<[^>]*>/g, '').replace(/&lt;[^&]*&gt;/gi, '').trim();
          var inSku = qModal.querySelector('[data-corp-quote-input-sku]');
          if (inSku) inSku.value = pSku;
        }
        if (pPrice || pSku) {
          var metaEl = qModal.querySelector('[data-corp-quote-meta]');
          if (metaEl) {
            var metaText = '';
            if (pSku) metaText += 'SKU ' + pSku + ' · ';
            if (pPrice) metaText += 'from ' + pPrice + ' / unit';
            metaEl.textContent = metaText;
          }
        }
        if (pImage) {
          var thumb = qModal.querySelector('[data-corp-quote-thumb]');
          var wrap = qModal.querySelector('[data-corp-quote-thumb-wrap]');
          if (thumb) {
            thumb.src = pImage;
            thumb.style.display = '';
          }
          if (wrap) wrap.style.display = '';
        }

        var qModalBoxes = Array.prototype.slice.call(qModal.querySelectorAll('input[type="checkbox"][name*="Branding"]'));
        qModalBoxes.forEach(function (mb) { mb.checked = false; });
        resetQuoteModalState(qModal);
        openModal(qModal, qBackdrop);
      });
    }

    // Close buttons & backdrops
    var closeButtons = Array.prototype.slice.call(document.querySelectorAll('[data-corp-modal-close]'));
    closeButtons.forEach(function (btn) {
      if (btn.getAttribute('data-close-bound') === 'true') return;
      btn.setAttribute('data-close-bound', 'true');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeAllModals();
      });
    });

    // Escape key listener
    if (!window.corpModalEscBound) {
      window.corpModalEscBound = true;
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
          closeAllModals();
        }
      });
    }

    // Silent sink iframe helper ensuring zero page reloads/redirects
    function ensureSilentSink() {
      if (!document.getElementById('corp_jdgm_silent_sink')) {
        var sink = document.createElement('iframe');
        sink.id = 'corp_jdgm_silent_sink';
        sink.name = 'corp_jdgm_silent_sink';
        sink.style.cssText = 'position:absolute;width:1px;height:1px;top:-9999px;left:-9999px;opacity:0;pointer-events:none;';
        sink.setAttribute('aria-hidden', 'true');
        document.body.appendChild(sink);
      }
    }

    // Helper to optimize and compress user images client-side before sending to Judge.me / localStorage
    function compressImageFiles(files, callback) {
      if (!files || !files.length) {
        callback([]);
        return;
      }
      var compressed = [];
      var remaining = files.length;
      var maxDim = 1200;
      var quality = 0.82;

      for (var i = 0; i < files.length; i++) {
        (function (file, index) {
          if (!file || !file.type || file.type.indexOf('image/') !== 0) {
            compressed[index] = file;
            remaining--;
            if (remaining === 0) callback(compressed.filter(Boolean));
            return;
          }
          var reader = new FileReader();
          reader.onload = function (e) {
            var img = new Image();
            img.onload = function () {
              try {
                var width = img.naturalWidth || img.width;
                var height = img.naturalHeight || img.height;
                if (width > maxDim || height > maxDim) {
                  if (width > height) {
                    height = Math.round((height * maxDim) / width);
                    width = maxDim;
                  } else {
                    width = Math.round((width * maxDim) / height);
                    height = maxDim;
                  }
                }
                var canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);

                if (canvas.toBlob) {
                  canvas.toBlob(function (blob) {
                    if (blob) {
                      var cleanFileName = (file.name || 'review-photo').replace(/\.[^.]+$/, '') + '.jpg';
                      var optFile = new File([blob], cleanFileName, { type: 'image/jpeg', lastModified: Date.now() });
                      compressed[index] = optFile;
                    } else {
                      compressed[index] = file;
                    }
                    remaining--;
                    if (remaining === 0) callback(compressed.filter(Boolean));
                  }, 'image/jpeg', quality);
                } else {
                  compressed[index] = file;
                  remaining--;
                  if (remaining === 0) callback(compressed.filter(Boolean));
                }
              } catch (errCanvas) {
                compressed[index] = file;
                remaining--;
                if (remaining === 0) callback(compressed.filter(Boolean));
              }
            };
            img.onerror = function () {
              compressed[index] = file;
              remaining--;
              if (remaining === 0) callback(compressed.filter(Boolean));
            };
            img.src = e.target.result;
          };
          reader.onerror = function () {
            compressed[index] = file;
            remaining--;
            if (remaining === 0) callback(compressed.filter(Boolean));
          };
          reader.readAsDataURL(file);
        })(files[i], i);
      }
    }

    // Helper to read files as Base64 Data URLs
    function readFilesAsDataUrls(files, callback) {
      if (!files || !files.length) {
        callback([]);
        return;
      }
      var results = [];
      var remaining = files.length;
      for (var i = 0; i < files.length; i++) {
        (function (file, index) {
          var reader = new FileReader();
          reader.onload = function (e) {
            results[index] = e.target.result;
            remaining--;
            if (remaining === 0) {
              callback(results.filter(Boolean));
            }
          };
          reader.onerror = function () {
            remaining--;
            if (remaining === 0) {
              callback(results.filter(Boolean));
            }
          };
          reader.readAsDataURL(file);
        })(files[i], i);
      }
    }

    // Judge.me S3 Direct Photo Uploader
    function uploadJudgeMePhotos(photoFiles, domain) {
      if (!photoFiles || !photoFiles.length) {
        return Promise.resolve([]);
      }
      var uploadPromises = photoFiles.map(function (file) {
        return new Promise(function (resOne) {
          try {
            var presignUrl = 'https://api.judge.me/api/v1/pictures/presigned_data?shop_domain=' + encodeURIComponent(domain) + '&platform=shopify&url=' + encodeURIComponent(domain);
            fetch(presignUrl)
              .then(function (res) { return res.json(); })
              .then(function (pData) {
                if (pData && pData.url && pData.fields) {
                  var s3Form = new FormData();
                  Object.keys(pData.fields).forEach(function (k) {
                    s3Form.append(k, pData.fields[k]);
                  });
                  s3Form.append('file', file, file.name);
                  fetch(pData.url, { method: 'POST', body: s3Form })
                    .then(function (s3Res) {
                      if (s3Res.ok || s3Res.status < 400) {
                        resOne(pData.fields.key);
                      } else {
                        resOne(null);
                      }
                    })
                    .catch(function () { resOne(null); });
                } else {
                  resOne(null);
                }
              })
              .catch(function () { resOne(null); });
          } catch (eP) {
            resOne(null);
          }
        });
      });
      return Promise.all(uploadPromises).then(function (keys) {
        return keys.filter(Boolean);
      });
    }

    // Direct API Submission to Judge.me Cloud (Works on Judge.me Free Plan without API token)
    function submitDirectToJudgeMe(prodId, rating, title, body, name, email, photoFiles, callback) {
      return new Promise(function (resolve) {
        try {
          var primaryDomain = 'ny1yrb-gd.myshopify.com';
          if (window.Shopify && window.Shopify.shop) {
            primaryDomain = window.Shopify.shop;
          } else if (window._corpProductInfo && window._corpProductInfo.shopDomain) {
            primaryDomain = window._corpProductInfo.shopDomain;
          }
          primaryDomain = String(primaryDomain || '').replace(/^https?:\/\//, '').replace(/\/$/, '').trim() || 'ny1yrb-gd.myshopify.com';

          var pId = String((window._corpProductInfo && window._corpProductInfo.id) || prodId || '').trim();
          if (!pId || pId === 'default' || pId === '0') {
            resolve({ status: 0, text: 'Missing product id; review could not be synced to Judge.me.' });
            return;
          }
          var pIdNum = parseInt(pId, 10);

          var token = String((window._corpProductInfo && window._corpProductInfo.jdgmPrivateToken) || (window.jdgmSettings && window.jdgmSettings.api_token) || '').trim();
          if (!token) {
            console.warn('[Corporate Reviews] Notice: No Judge.me Private API Token configured. Enter your token in Theme Customizer > Corporate: Reviews to sync directly to Judge.me Dashboard.');
          }



          var ratingNum = Math.max(1, Math.min(5, parseInt(rating, 10) || 5));
          var safeName = (name || '').trim() || 'Corporate Buyer';
          var safeEmail = (email || '').trim() || 'buyer@corporate.order';
          var safeTitle = (title || '').trim();
          var safeBody = String(body || '').replace(/\[corporate:[^\]]*\]/gi, '').trim();

          uploadJudgeMePhotos(photoFiles, primaryDomain).then(function (pictureKeys) {
            var fd = new FormData();
            fd.append('shop_domain', primaryDomain);
            fd.append('platform', 'shopify');
            fd.append('url', primaryDomain);
            fd.append('id', pIdNum);
            fd.append('product_id', pIdNum);
            fd.append('product_external_id', pIdNum);
            fd.append('name', safeName);
            fd.append('reviewer_name', safeName);
            fd.append('email', safeEmail);
            fd.append('reviewer_email', safeEmail);
            fd.append('rating', ratingNum);
            fd.append('title', safeTitle);
            fd.append('review_title', safeTitle);
            fd.append('body', safeBody);
            fd.append('review_body', safeBody);
            fd.append('reviewer_name_format', '');

            if (token) {
              fd.append('api_token', token);
            }

            if (pictureKeys && pictureKeys.length) {
              pictureKeys.forEach(function (k) {
                fd.append('picture_keys[]', k);
              });
            }

            if (photoFiles && photoFiles.length) {
              photoFiles.forEach(function (f) {
                fd.append('pictures[]', f, f.name);
                fd.append('photos[]', f, f.name);
                fd.append('media[]', f, f.name);
                fd.append('review[pictures][]', f, f.name);
              });
            }

            var postEndpoints = [
              'https://api.judge.me/api/v1/reviews' + ('?shop_domain=' + encodeURIComponent(primaryDomain) + (token ? '&api_token=' + encodeURIComponent(token) : '')),
              'https://judge.me/api/v1/reviews' + ('?shop_domain=' + encodeURIComponent(primaryDomain) + (token ? '&api_token=' + encodeURIComponent(token) : ''))
            ];

            var fetchHeaders = { 'Accept': 'application/json' };
            if (token) {
              fetchHeaders['X-Api-Token'] = token;
            }

            var submitPromises = postEndpoints.map(function (url) {
              return fetch(url, {
                method: 'POST',
                body: fd,
                headers: fetchHeaders
              }).then(function (res) {
                return res.text().then(function (txt) {
                  console.log('[Corporate Reviews] Judge.me API response status (' + url.split('?')[0] + '):', res.status, txt || '');
                  return { status: res.status, text: txt || '' };
                });
              }).catch(function (err) {
                return { status: 0, text: err ? err.message : 'failed' };
              });
            });

            Promise.all(submitPromises).then(function (results) {
              var successResult = (results[0].status >= 200 && results[0].status < 400) ? results[0] : results[1];
              if (typeof callback === 'function') callback(successResult);
              resolve(successResult);
            });
          }).catch(function () {
            resolve({ status: 0, text: 'Photo upload error' });
          });
        } catch (e) {
          console.warn('[Corporate Reviews] submitDirectToJudgeMe error:', e);
          resolve({ status: 0, text: e && e.message ? e.message : 'Judge.me submission failed' });
        }
      });
    }

    // Ensure Judge.me settings are configured for widget review flow
    if (typeof window !== 'undefined' && window.jdgmSettings) {
      window.jdgmSettings.modal_write_review_flow = false;
      window.jdgmSettings.review_form_theme = 'default';

    }

    // Forward review details into Judge.me live widget form
    function getJdgmForm() {
      return document.querySelector('form.jdgm-form, .corp-jdgm-bridge-wrap form, #judgeme_product_reviews form, .jdgm-form, .jdgm-form-wrapper form, .jdgm-write-review-modal form, [data-jdgm-modal] form');
    }

    // Safely set input values, firing both DOM and jQuery events, while strictly protecting against honeypot fields
    function safeSetInput(input, val) {
      if (!input) return;
      var inputName = (input.getAttribute('name') || '').toLowerCase();
      // Anti-bot honeypot protection: NEVER populate input[name="name"]
      if (inputName === 'name') return;
      input.value = val;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (typeof jQuery !== 'undefined') {
        try { jQuery(input).val(val).trigger('input').trigger('change'); } catch (e) { }
      }
    }

    function safeClick(el) {
      if (!el) return;
      try {
        var evt = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
        el.dispatchEvent(evt);
      } catch (e) {
        try { el.click(); } catch (e2) { }
      }
      if (typeof jQuery !== 'undefined') {
        try { jQuery(el).trigger('click'); } catch (je) { }
      }
    }

    // Ensure the Judge.me widget is initialized and off-screen form is generated
    function ensureJdgmForm(callback) {
      if (typeof window !== 'undefined' && window.jdgmSettings) {
        window.jdgmSettings.modal_write_review_flow = false;
        window.jdgmSettings.review_form_theme = 'default';
  
      }

      try {
        if (window.jdgm && typeof window.jdgm.initializeWidgets === 'function') {
          window.jdgm.initializeWidgets();
        } else if (window.jdgm && typeof window.jdgm.loadWidgets === 'function') {
          window.jdgm.loadWidgets();
        }
      } catch (e) { }

      var form = getJdgmForm();
      if (form) {
        if (typeof callback === 'function') callback(form);
        return form;
      }

      var writeLinks = document.querySelectorAll('#judgeme_product_reviews .jdgm-write-rev-link, .corp-jdgm-bridge-wrap .jdgm-write-rev-link, .jdgm-write-rev-link, .jdgm-rev-widg__write-review-link, [data-jdgm-write-review]');
      writeLinks.forEach(function (link) {
        safeClick(link);
      });

      var attempts = 0;
      var timer = setInterval(function () {
        attempts++;
        var spawnedForm = getJdgmForm();
        if (spawnedForm) {
          clearInterval(timer);
          if (typeof callback === 'function') callback(spawnedForm);
        } else if (attempts > 30) {
          clearInterval(timer);
          if (typeof callback === 'function') callback(null);
        }
      }, 100);
    }

    // Pre-warm the Judge.me form off-screen so it is rendered and ready before submission
    function prewarmJdgmForm() {
      var pollAttempts = 0;
      var pollInterval = setInterval(function () {
        pollAttempts++;
        if (getJdgmForm() || pollAttempts > 15) {
          clearInterval(pollInterval);
          return;
        }
        ensureJdgmForm();
      }, 600);
    }
    // prewarmJdgmForm is intentionally NOT run on page load to preserve Judge.me review list

    // Forward review details into Judge.me live widget form
    function forwardReviewToJudgeMe(ratingScore, titleVal, enrichedBody, nameVal, emailVal, photoFiles, prodId, shopDomain) {
      var apiPromise = submitDirectToJudgeMe(prodId, ratingScore, titleVal, enrichedBody, nameVal, emailVal, photoFiles, function () { });

      function driveJudgeMeForm(jdgForm) {
        if (!jdgForm) return;

        // Force form submission to stay strictly in the silent sink iframe
        ensureSilentSink();
        try {
          jdgForm.setAttribute('target', 'corp_jdgm_silent_sink');
          if (!jdgForm.getAttribute('data-sink-bound')) {
            jdgForm.setAttribute('data-sink-bound', 'true');
            jdgForm.addEventListener('submit', function () {
              jdgForm.setAttribute('target', 'corp_jdgm_silent_sink');
            });
          }
        } catch (eSink) { }

        // --- PHASE 1: Rating Score ---
        var starBtn = jdgForm.querySelector('.jdgm-form__rating .jdgm-star[data-score="' + ratingScore + '"]')
          || jdgForm.querySelector('.jdgm-star[data-score="' + ratingScore + '"]')
          || jdgForm.querySelector('[data-score="' + ratingScore + '"]');
        if (starBtn) {
          safeClick(starBtn);
        }
        jdgForm.querySelectorAll('input[name="score"], input[name="rating"], input[name*="rating"], input[name="review[rating]"], input.jdgm-form__rating-input').forEach(function (inp) {
          safeSetInput(inp, ratingScore);
        });

        // --- PHASE 2: Title & Body ---
        jdgForm.querySelectorAll('input.jdgm-form__title, input[name="review[title]"], input[name="review_title"], input[name="title"]').forEach(function (inp) {
          safeSetInput(inp, titleVal);
        });
        jdgForm.querySelectorAll('textarea.jdgm-form__body, textarea[name="review[body]"], textarea[name="review_body"], textarea[name="body"]').forEach(function (inp) {
          safeSetInput(inp, enrichedBody);
        });

        // --- PHASE 3: Author Name & Email (NEVER populate honeypot input[name="name"]) ---
        jdgForm.querySelectorAll('input.jdgm-form__reviewer-name, input[name="review[reviewer_name]"], input[name="reviewer_name"], input[name="author"], input[name*="reviewer_name"]').forEach(function (inp) {
          safeSetInput(inp, nameVal);
        });
        jdgForm.querySelectorAll('input.jdgm-form__reviewer-email, input[name="review[reviewer_email]"], input[name="reviewer_email"], input[type="email"]').forEach(function (inp) {
          safeSetInput(inp, emailVal);
        });
        jdgForm.querySelectorAll('input[name="reviewer_name_format"]').forEach(function (inp) {
          safeSetInput(inp, '');
        });

        // Attach photos if present
        if (photoFiles && photoFiles.length) {
          var fileInps = jdgForm.querySelectorAll('input[type="file"], input[name="media"], input[name*="pic"], input[name*="photo"], .jdgm-picture-input');
          fileInps.forEach(function (finp) {
            try {
              var dt = new DataTransfer();
              for (var i = 0; i < photoFiles.length; i++) {
                dt.items.add(photoFiles[i]);
              }
              finp.files = dt.files;
              finp.dispatchEvent(new Event('input', { bubbles: true }));
              finp.dispatchEvent(new Event('change', { bubbles: true }));
              if (typeof jQuery !== 'undefined') {
                try { jQuery(finp).trigger('change'); } catch (je) { }
              }
            } catch (e) { }
          });
        }

        // --- PHASE 4: Multi-step screen advancement & final submission ---
        function tryAdvanceAndSubmit(stepCount) {
          stepCount = stepCount || 0;
          if (stepCount > 6) return;

          // Re-populate fields on currently active screen
          jdgForm.querySelectorAll('input.jdgm-form__title, input[name="review[title]"], input[name="review_title"]').forEach(function (inp) {
            if (!inp.value) safeSetInput(inp, titleVal);
          });
          jdgForm.querySelectorAll('textarea.jdgm-form__body, textarea[name="review[body]"], textarea[name="review_body"]').forEach(function (inp) {
            if (!inp.value) safeSetInput(inp, enrichedBody);
          });
          jdgForm.querySelectorAll('input.jdgm-form__reviewer-name, input[name="review[reviewer_name]"], input[name="reviewer_name"]').forEach(function (inp) {
            if (!inp.value) safeSetInput(inp, nameVal);
          });
          jdgForm.querySelectorAll('input.jdgm-form__reviewer-email, input[name="review[reviewer_email]"], input[name="reviewer_email"]').forEach(function (inp) {
            if (!inp.value) safeSetInput(inp, emailVal);
          });

          // Check if there is an active "Next" button
          var nextBtn = jdgForm.querySelector('.jdgm-btn--next:not([style*="display: none"]), [data-screen]:not([style*="display: none"]) button.jdgm-btn--primary:not(.jdgm-submit-rev)');
          if (nextBtn && !nextBtn.classList.contains('jdgm-submit-rev') && !nextBtn.classList.contains('jdgm-submit-btn')) {
            safeClick(nextBtn);
            setTimeout(function () {
              tryAdvanceAndSubmit(stepCount + 1);
            }, 250);
            return;
          }

          // Otherwise, we are on the final screen: Trigger submit button
          var submitDelay = (photoFiles && photoFiles.length) ? 1200 : 250;
          setTimeout(function () {
            ensureSilentSink();
            jdgForm.setAttribute('target', 'corp_jdgm_silent_sink');

            var finalSubmitBtn = jdgForm.querySelector('.jdgm-submit-rev, .jdgm-submit-btn, button[type="submit"], input[type="submit"], button.jdgm-btn--primary, input.jdgm-btn--primary');
            if (finalSubmitBtn) {
              var attemptsLeft = (photoFiles && photoFiles.length) ? 25 : 2;
              function pollAndClickSubmit() {
                var isBlocked = finalSubmitBtn && (finalSubmitBtn.disabled || finalSubmitBtn.classList.contains('jdgm-btn--disabled') || jdgForm.querySelector('.jdgm--loading, .jdgm-spinner'));
                if (isBlocked && attemptsLeft > 0) {
                  attemptsLeft--;
                  setTimeout(pollAndClickSubmit, 200);
                  return;
                }
                if (isBlocked && finalSubmitBtn) {
                  try {
                    var fInps = jdgForm.querySelectorAll('input[type="file"], .jdgm-picture-input');
                    fInps.forEach(function (fi) { fi.value = ''; });
                    finalSubmitBtn.removeAttribute('disabled');
                    finalSubmitBtn.classList.remove('jdgm-btn--disabled');
                  } catch (eF) { }
                }
                safeClick(finalSubmitBtn);
              }
              pollAndClickSubmit();
            }

            // Also send POST via fetch as an additional guarantee if action is valid
            try {
              var fAction = jdgForm.getAttribute('action');
              if (fAction && fAction !== '#' && fAction !== '' && fAction.indexOf('javascript:') === -1) {
                fetch(fAction, {
                  method: 'POST',
                  body: new FormData(jdgForm)
                }).catch(function () { });
              }
            } catch (errAct) { }
          }, submitDelay);
        }

        setTimeout(function () {
          tryAdvanceAndSubmit(0);
        }, 200);
      }

      ensureJdgmForm(function (form) {
        if (form) {
          driveJudgeMeForm(form);
        }
      });

      return apiPromise;
    }

    // Resolve Shopify's own contact endpoint (locale / market aware).
    // {% form 'contact' %} renders the correct action; never hardcode /contact.
    function getContactAction(form) {
      var formAction = form ? form.getAttribute('action') : '';
      if (formAction && formAction !== '#' && formAction.indexOf('javascript:') === -1) {
        return formAction.split('#')[0];
      }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      return root.replace(/\/+$/, '') + '/contact';
    }

    // Dedicated Submission Handler: Quote Popup Modal
    function submitModalQuoteForm(form) {
      if (!form) return;
      var quoteAction = getContactAction(form);

      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        if (typeof form.reportValidity === 'function') form.reportValidity();
        return;
      }

      var fieldsWrap = form.querySelector('[data-corp-modal-fields]');
      var successMsg = form.querySelector('[data-corp-modal-success]');
      var errorMsg = form.querySelector('[data-corp-modal-error]');
      var submitBtn = form.querySelector('[data-corp-modal-submit]');

      var hpField = form.querySelector('input[name="corp_hp_url"], input[name="website"]');
      if (hpField && hpField.value) {
        if (fieldsWrap) fieldsWrap.style.display = 'none';
        if (errorMsg) errorMsg.style.display = 'none';
        if (successMsg) successMsg.style.display = 'block';
        if (submitBtn) submitBtn.style.display = 'none';
        return;
      }

      if (form._corpSubmitting) return;
      form._corpSubmitting = true;

      if (submitBtn) {
        if (!submitBtn.getAttribute('data-original-label')) {
          submitBtn.setAttribute('data-original-label', submitBtn.textContent.trim());
        }
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending...';
      }
      if (errorMsg) {
        errorMsg.style.display = 'none';
        errorMsg.textContent = '';
      }

      var quoteFormData = new FormData();
      var rawFormData = new FormData(form);
      rawFormData.forEach(function (val, key) {
        if (val instanceof File) {
          if (val.name) quoteFormData.append(key, val.name);
        } else {
          quoteFormData.append(key, val);
        }
      });

      fetch(quoteAction, {
        method: 'POST',
        body: quoteFormData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        redirect: 'follow'
      }).then(function (res) {
        form._corpSubmitting = false;
        var isSuccess = res.ok && /(?:^|[?&])contact_posted=true/.test(res.url || '');
        if (isSuccess) {
          if (fieldsWrap) fieldsWrap.style.display = 'none';
          if (errorMsg) errorMsg.style.display = 'none';
          if (successMsg) {
            successMsg.style.display = 'block';
            try { successMsg.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (scrollErr) { }
          }
          if (submitBtn) submitBtn.style.display = 'none';
          try {
            console.log('%c[Corporate Quote] Modal quote submitted successfully!', 'background: #2e7d32; color: #fff; font-weight: bold; padding: 2px 6px; border-radius: 3px;');
            if (console.table) {
              console.table({
                'Status': 'HTTP ' + res.status + ' OK',
                'Product': form.querySelector('[data-corp-quote-input-product]') ? form.querySelector('[data-corp-quote-input-product]').value : 'N/A',
                'SKU': form.querySelector('[data-corp-quote-input-sku]') ? form.querySelector('[data-corp-quote-input-sku]').value : 'N/A',
                'Source Page': form.querySelector('input[name="contact[Source Page]"]') ? form.querySelector('input[name="contact[Source Page]"]').value : window.location.href,
                'Sent To': 'support@giheritage.com'
              });
            }
          } catch (logErr) { }
          try {
            if (window.history && window.history.replaceState) {
              sanitizeBrowserUrl();
            }
          } catch (urlErr) { }
        } else {
          throw new Error('Quote submission did not return contact_posted flag');
        }
      }).catch(function (err) {
        form._corpSubmitting = false;
        console.warn('[Corporate Quote] Submission failed:', err);
        if (fieldsWrap) fieldsWrap.style.display = '';
        if (errorMsg) {
          errorMsg.textContent = 'Could not send your request. Please try again, or WhatsApp us on +91 98117 70528.';
          errorMsg.style.display = 'block';
          try { errorMsg.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (scrollErr) { }
        }
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.style.display = '';
          var origText = submitBtn.getAttribute('data-original-label');
          if (origText) submitBtn.textContent = origText;
        }
      });
    }

    // Dedicated Submission Handler: On-Page Quote Form (Landing Page & Quote Page)
    function submitPageQuoteForm(pForm) {
      if (!pForm) return;
      var pageAction = getContactAction(pForm);

      if (typeof pForm.checkValidity === 'function' && !pForm.checkValidity()) {
        if (typeof pForm.reportValidity === 'function') pForm.reportValidity();
        return;
      }

      var hp = pForm.querySelector('input[name="corp_hp_url"], input[name="website"]');
      var fields = pForm.querySelector('[data-corp-page-fields]');
      var succ = pForm.querySelector('[data-corp-page-success]');
      var errEl = pForm.querySelector('[data-corp-page-error]');

      if (hp && hp.value) {
        if (fields) fields.style.display = 'none';
        if (succ) succ.style.display = 'block';
        return;
      }

      if (pForm._corpSubmitting) return;
      pForm._corpSubmitting = true;

      var btn = pForm.querySelector('button[type="submit"]');
      if (btn) {
        if (!btn.getAttribute('data-original-label')) {
          btn.setAttribute('data-original-label', btn.textContent.trim());
        }
        btn.disabled = true;
        btn.textContent = 'Sending...';
      }
      if (errEl) {
        errEl.style.display = 'none';
        errEl.textContent = '';
      }

      var postData = new FormData(pForm);

      fetch(pageAction, {
        method: 'POST',
        body: postData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        redirect: 'follow'
      }).then(function (res) {
        pForm._corpSubmitting = false;
        var isSuccess = res.ok && /(?:^|[?&])contact_posted=true/.test(res.url || '');
        if (isSuccess) {
          if (fields) fields.style.display = 'none';
          if (errEl) errEl.style.display = 'none';
          if (succ) {
            succ.style.display = 'block';
            try { succ.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (scrollErr) { }
          }
          try {
            if (window.history && window.history.replaceState) {
              sanitizeBrowserUrl();
            }
          } catch (urlErr) { }
        } else {
          throw new Error('On-page quote submission failed');
        }
      }).catch(function (fetchErr) {
        pForm._corpSubmitting = false;
        console.warn('[Corporate Page Quote] Submission failed:', fetchErr);
        if (fields) fields.style.display = '';
        if (errEl) {
          errEl.textContent = 'Could not send your request. Please try again, or WhatsApp us on +91 98117 70528.';
          errEl.style.display = 'block';
          try { errEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (scrollErr) { }
        }
        if (btn) {
          btn.disabled = false;
          btn.textContent = btn.getAttribute('data-original-label') || 'Request a Quote';
        }
      });
    }

    // Modal Form Submissions with AJAX & Smart Judge.me Bridge
    var setupModalForm = function (formId) {
      var form = document.getElementById(formId)
        || (formId === 'corp-review-modal-form' ? document.querySelector('#corp-review-modal form, [data-corp-review-form]') : null)
        || (formId === 'corp-quote-modal-form' ? document.querySelector('#corp-quote-modal form, [data-corp-quote-form]') : null);

      if (form && (formId === 'corp-quote-modal-form' || form.id === 'corp-quote-modal-form' || form.hasAttribute('data-corp-quote-form'))) {
        if (!form.getAttribute('data-ajax-bound')) {
          form.setAttribute('data-ajax-bound', 'true');
          form.addEventListener('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();
            submitModalQuoteForm(form);
          });
        }
        return;
      }

      if (!form || form.getAttribute('data-ajax-bound') === 'true') return;
      form.setAttribute('data-ajax-bound', 'true');

      ensureSilentSink();
      form.setAttribute('target', 'corp_jdgm_silent_sink');

      form.addEventListener('submit', function (e) {
        // ALWAYS prevent default immediately to eliminate any chance of page redirect
        e.preventDefault();
        e.stopPropagation();

        if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
          if (typeof form.reportValidity === 'function') {
            form.reportValidity();
          }
          return;
        }

        var submitBtn = form.querySelector('[data-corp-modal-submit]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Submitting...';
        }

        var fieldsWrap = form.querySelector('[data-corp-modal-fields]');
        var successMsg = form.querySelector('[data-corp-modal-success]');
        var errorMsg = form.querySelector('[data-corp-modal-error]');

        var formData = new FormData(form);

        if (formId === 'corp-review-modal-form' || form.hasAttribute('data-corp-review-form')) {
          var ratingInput = form.querySelector('input[name="contact[Rating]"]:checked');
          var ratingScore = ratingInput ? parseInt(ratingInput.value, 10) : 5;

          var titleInput = form.querySelector('input[name="contact[Review title]"]');
          var titleVal = titleInput ? titleInput.value.trim() : '';

          var bodyInput = form.querySelector('textarea[name="contact[body]"]');
          var bodyVal = bodyInput ? bodyInput.value.trim() : '';

          var nameInput = form.querySelector('input[name="contact[name]"]');
          var nameVal = nameInput ? nameInput.value.trim() : '';

          var emailInput = form.querySelector('input[name="contact[email]"]');
          var emailVal = emailInput ? emailInput.value.trim() : '';

          var companyInput = form.querySelector('input[name="contact[Company]"]');
          var companyVal = companyInput ? companyInput.value.trim() : '';

          // Trick for Judge.me Free Plan: include company in name ("Name - Company") so Judge.me accepts it
          var formattedName = companyVal ? (nameVal + ' - ' + companyVal) : nameVal;

          var rawBody = bodyVal;
          if (false && companyVal) {
            enrichedBody = bodyVal + '\n\n[Corporate: Company: ' + companyVal + ']';
          }
          formData.set('contact[body]', rawBody);

          var photoInp = form.querySelector('[data-corp-photo-input]');
          var photoFiles = (photoInp && photoInp._corpFiles && photoInp._corpFiles.length)
            ? photoInp._corpFiles
            : (photoInp && photoInp.files && photoInp.files.length ? Array.prototype.slice.call(photoInp.files) : []);

          if (photoFiles.length) {
            formData.set('contact[Photos]', photoFiles.map(function (f) { return f.name; }).join(', '));
          }

          var prodId = (window._corpProductInfo && window._corpProductInfo.id)
            || form.getAttribute('data-product-id')
            || (form.querySelector('[data-corp-rev-id]') ? form.querySelector('[data-corp-rev-id]').value : '')
            || (form.querySelector('input[name="product_id"]') ? form.querySelector('input[name="product_id"]').value : '')
            || (reviewModal ? reviewModal.getAttribute('data-product-id') : '')
            || (document.getElementById('judgeme_product_reviews') ? document.getElementById('judgeme_product_reviews').getAttribute('data-id') : '');

          var prodHandle = (window._corpProductInfo && window._corpProductInfo.handle)
            || (window.location && window.location.pathname ? window.location.pathname.split('/products/')[1] || '' : '')
            || (form.getAttribute('data-product-handle') || '');

          var shopDomain = (window._corpProductInfo && window._corpProductInfo.shopDomain)
            || form.getAttribute('data-shop-domain')
            || (form.querySelector('[data-corp-shop-domain]') ? form.querySelector('[data-corp-shop-domain]').value : '')
            || (form.querySelector('input[name="shop_domain"]') ? form.querySelector('input[name="shop_domain"]').value : '')
            || (reviewModal ? reviewModal.getAttribute('data-shop-domain') : '')
            || 'ny1yrb-gd.myshopify.com';

          // Convert photos to permanent Base64 data URLs so they persist across page refreshes
          compressImageFiles(photoFiles, function (compressedFiles) {
            photoFiles = compressedFiles; readFilesAsDataUrls(photoFiles, function (dataUrls) {
              var localReview = {
                title: titleVal,
                body: bodyVal,
                name: nameVal,
                author: nameVal,
                company: companyVal,
                rating: ratingScore,
                date: new Date().toISOString(),
                photos: dataUrls,
                verified: true,
                corporate: true,
                source: 'custom-local'
              };

              saveLocalReview(prodId, prodHandle, localReview);

              // Immediately display newly submitted review on the PDP track
              var rootSection = form.closest('.corp-reviews') || document.querySelector('.corp-reviews') || document;
              var track = rootSection.querySelector('.corp-review-track[data-corp-reviews]');
              var populatedEl = rootSection.querySelector('[data-corp-reviews-populated]');
              var emptyEl = rootSection.querySelector('[data-corp-reviews-empty]');

              if (emptyEl) emptyEl.style.display = 'none';
              if (populatedEl) populatedEl.style.display = '';

              if (track) {
                var newSlide = buildReviewCardDOM({
                  rating: ratingScore,
                  title: titleVal,
                  body: bodyVal,
                  name: nameVal,
                  company: companyVal,
                  date: 'Just now',
                  photos: dataUrls,
                  verified: true
                }, true);
                newSlide.setAttribute('data-corp-local-review', 'true');
                track.insertBefore(newSlide, track.firstChild);

                var slider = track.closest('[data-corp-slider]');
                if (slider) {
                  slider.removeAttribute('data-slider-ready');
                  initFeaturedSlider(slider.parentElement || rootSection);
                }
              }

              if (dataUrls.length) {
                var photosWrap = rootSection.querySelector('.corp-buyer-photos[data-corp-buyer-photos]');
                var photosRow = rootSection.querySelector('.corp-buyer-photos__row');
                if (photosWrap) photosWrap.style.display = '';
                if (photosRow) {
                  dataUrls.forEach(function (url) {
                    var photoSpan = document.createElement('span');
                    photoSpan.className = 'corp-buyer-photo corp-buyer-photo--local';
                    var pImg = document.createElement('img');
                    pImg.src = url;
                    pImg.alt = 'Verified buyer photo';
                    pImg.loading = 'lazy';
                    photoSpan.appendChild(pImg);
                    photosRow.insertBefore(photoSpan, photosRow.firstChild);
                  });
                }
              }
            });

            // Keep the modal UX smooth
            if (fieldsWrap) fieldsWrap.style.display = 'none';
  
            if (errorMsg) errorMsg.style.display = 'none';

            var reviewPromise = forwardReviewToJudgeMe(ratingScore, titleVal, rawBody, formattedName, emailVal, photoFiles, prodId, shopDomain);
            reviewPromise.then(function () {
              if (successMsg) {
                successMsg.style.display = 'block';
                try { successMsg.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (err) { }
              }
              if (submitBtn) { submitBtn.style.display = 'none';

              }
    
            }).catch(function () {
              if (successMsg) {
                successMsg.style.display = 'block';
              }
            });

            setTimeout(function () {
              closeModal(reviewModal, reviewBackdrop);
              var revAnchor = document.getElementById('corporate-reviews');
              if (revAnchor) {
                revAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }, 2500);
          });
        } else {
          // Quote modal handled by submitModalQuoteForm
          var hpField = form.querySelector('input[name="corp_hp_url"], input[name="website"]');
          if (hpField && hpField.value) {
            if (fieldsWrap) fieldsWrap.style.display = 'none';
  
            if (errorMsg) errorMsg.style.display = 'none';
            if (successMsg) successMsg.style.display = 'block';
            if (submitBtn) submitBtn.style.display = 'none';
          try {
            console.log('%c[Corporate Quote] Modal quote submitted successfully!', 'background: #2e7d32; color: #fff; font-weight: bold; padding: 2px 6px; border-radius: 3px;');
            if (console.table) {
              console.table({
                'Status': 'HTTP ' + res.status + ' OK',
                'Product': form.querySelector('[data-corp-quote-input-product]') ? form.querySelector('[data-corp-quote-input-product]').value : 'N/A',
                'SKU': form.querySelector('[data-corp-quote-input-sku]') ? form.querySelector('[data-corp-quote-input-sku]').value : 'N/A',
                'Source Page': form.querySelector('input[name="contact[Source Page]"]') ? form.querySelector('input[name="contact[Source Page]"]').value : window.location.href,
                'Sent To': 'support@giheritage.com'
              });
            }
          } catch (logErr) { }
  
            return;
          }

          if (form._corpSubmitting) return;
          form._corpSubmitting = true;

          if (submitBtn) {
            if (!submitBtn.getAttribute('data-original-label')) {
              submitBtn.setAttribute('data-original-label', submitBtn.textContent.trim());
            }
            submitBtn.disabled = true;
            submitBtn.textContent = 'Sending...';
          }
          if (errorMsg) {
            errorMsg.style.display = 'none';
            errorMsg.textContent = '';
          }

          var quoteFormData = new FormData();
          formData.forEach(function (val, key) {
            if (val instanceof File) {
              if (val.name) quoteFormData.append(key, val.name);
            } else {
              quoteFormData.append(key, val);
            }
          });

          var postAction = getContactAction(form);

          fetch(postAction, {
            method: 'POST',
            body: quoteFormData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            redirect: 'follow'
          }).then(function (res) {
            form._corpSubmitting = false;
            var isSuccess = res.ok && /(?:^|[?&])contact_posted=true/.test(res.url || '');
            if (isSuccess) {
              if (fieldsWrap) fieldsWrap.style.display = 'none';
              if (errorMsg) errorMsg.style.display = 'none';
              if (successMsg) {
                successMsg.style.display = 'block';
                try { successMsg.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (scrollErr) { }
              }
              if (submitBtn) submitBtn.style.display = 'none';
          try {
            console.log('%c[Corporate Quote] Modal quote submitted successfully!', 'background: #2e7d32; color: #fff; font-weight: bold; padding: 2px 6px; border-radius: 3px;');
            if (console.table) {
              console.table({
                'Status': 'HTTP ' + res.status + ' OK',
                'Product': form.querySelector('[data-corp-quote-input-product]') ? form.querySelector('[data-corp-quote-input-product]').value : 'N/A',
                'SKU': form.querySelector('[data-corp-quote-input-sku]') ? form.querySelector('[data-corp-quote-input-sku]').value : 'N/A',
                'Source Page': form.querySelector('input[name="contact[Source Page]"]') ? form.querySelector('input[name="contact[Source Page]"]').value : window.location.href,
                'Sent To': 'support@giheritage.com'
              });
            }
          } catch (logErr) { }
            } else {
              throw new Error('Quote submission did not return contact_posted flag');
            }
          }).catch(function (err) {
            form._corpSubmitting = false;
            console.warn('[Corporate Quote] Submission failed:', err);
            if (fieldsWrap) fieldsWrap.style.display = '';
            if (errorMsg) {
              errorMsg.textContent = 'Could not send your request. Please try again, or WhatsApp us on +91 98117 70528.';
              errorMsg.style.display = 'block';
              try { errorMsg.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (scrollErr) { }
            }
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.style.display = '';
              var origText = submitBtn.getAttribute('data-original-label');
              if (origText) submitBtn.textContent = origText;
            }
          });
          return;
        }
        if (false) {


          if (errorMsg) errorMsg.style.display = 'none';
          if (successMsg) successMsg.style.display = 'block';

        }

        // Background backup submission to Shopify contact form
        try {
          var contactFormData = new FormData();
          formData.forEach(function (val, key) {
            if (val instanceof File) {
              if (val.name) {
                contactFormData.append(key, val.name);
              }
            } else {
              contactFormData.append(key, val);
            }
          });

          fetch(form.getAttribute('action') || '/contact', {
            method: 'POST',
            body: contactFormData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          }).then(function (res) {
            console.log('[Corporate Reviews] Shopify contact form backup response status:', res.status);
          }).catch(function (err) {
            console.warn('[Corporate Reviews] Shopify contact backup error:', err);
          });
        } catch (e) { }
      });
    };

    setupModalForm('corp-review-modal-form');
    setupModalForm('corp-quote-modal-form');

    // Standalone on-page quote forms (landing page split form & quote page card form)
    var setupPageQuoteForms = function () {
      var pageQuoteForms = document.querySelectorAll('form[id^="corp-quote-"]:not(#corp-quote-modal-form), [data-corp-quote-page-form]');
      Array.prototype.slice.call(pageQuoteForms).forEach(function (pForm) {
        if (pForm.getAttribute('data-corp-ajax-bound') === 'true') return;
        pForm.setAttribute('data-corp-ajax-bound', 'true');

        pForm.addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (typeof pForm.checkValidity === 'function' && !pForm.checkValidity()) {
            if (typeof pForm.reportValidity === 'function') pForm.reportValidity();
            return;
          }

          var hp = pForm.querySelector('input[name="corp_hp_url"], input[name="website"]');
          var fields = pForm.querySelector('[data-corp-page-fields]');
          var succ = pForm.querySelector('[data-corp-page-success]');
          var errEl = pForm.querySelector('[data-corp-page-error]');

          if (hp && hp.value) {
            // Honeypot trapped bot: silent drop
            if (fields) fields.style.display = 'none';
            if (succ) succ.style.display = 'block';
            return;
          }

          if (pForm._corpSubmitting) return;
          pForm._corpSubmitting = true;

          var btn = pForm.querySelector('button[type="submit"]');
          if (btn) {
            if (!btn.getAttribute('data-original-label')) {
              btn.setAttribute('data-original-label', btn.textContent.trim());
            }
            btn.disabled = true;
            btn.textContent = 'Sending...';
          }
          if (errEl) {
            errEl.style.display = 'none';
            errEl.textContent = '';
          }

          var postData = new FormData(pForm);
          var postAction = getContactAction(pForm);

          fetch(postAction, {
            method: 'POST',
            body: postData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            redirect: 'follow'
          }).then(function (res) {
            pForm._corpSubmitting = false;
            var isSuccess = res.ok && /(?:^|[?&])contact_posted=true/.test(res.url || '');
            if (isSuccess) {
              if (fields) fields.style.display = 'none';
              if (errEl) errEl.style.display = 'none';
              if (succ) {
                succ.style.display = 'block';
                try { succ.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (scrollErr) { }
              }
              // Clean address bar so no ?contact_posted=true#corp-quote-... ever appears
              try {
                if (window.history && window.history.replaceState) {
                  sanitizeBrowserUrl();
                }
              } catch (urlErr) { }
            } else {
              throw new Error('On-page quote submission failed');
            }
          }).catch(function (fetchErr) {
            pForm._corpSubmitting = false;
            console.warn('[Corporate Page Quote] Submission failed:', fetchErr);
            if (fields) fields.style.display = '';
            if (errEl) {
              errEl.textContent = 'Could not send your request. Please try again, or WhatsApp us on +91 98117 70528.';
              errEl.style.display = 'block';
              try { errEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (scrollErr) { }
            }
            if (btn) {
              btn.disabled = false;
              btn.textContent = btn.getAttribute('data-original-label') || 'Request a Quote';
            }
          });
        });
      });
    };

    setupPageQuoteForms();

    // Global capture-phase submit interceptor for all corporate quote forms
    if (!window._corpCaptureQuoteSubmitBound) {
      window._corpCaptureQuoteSubmitBound = true;
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form) return;

        var isPageQuote = (form.id && form.id.indexOf('corp-quote-') === 0 && form.id !== 'corp-quote-modal-form')
          || form.hasAttribute('data-corp-quote-page-form');
        if (isPageQuote) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          submitPageQuoteForm(form);
          return false;
        }

        var isModalQuote = form.id === 'corp-quote-modal-form' || form.hasAttribute('data-corp-quote-form');
        if (isModalQuote) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          submitModalQuoteForm(form);
          return false;
        }
      }, true);
    }

    // Silently remove leftover ?contact_posted=true or #corp-quote-... hash if already present in URL
    try {
      if (window.location && (window.location.search.indexOf('contact_posted=true') !== -1 || window.location.hash.indexOf('corp-quote') !== -1)) {
        if (window.history && window.history.replaceState) {
          var cleanSearch = window.location.search.replace(/[?&]contact_posted=true(&|$)/, function (m, p) { return p === '&' ? '?' : ''; }).replace(/\?$/, '');
          sanitizeBrowserUrl();
        }
      }
    } catch (cleanUrlErr) { }

    // Also support standalone corporate review form page with AJAX & Judge.me forwarding
    var standaloneReviewForm = document.querySelector('.corp-review-page__form');
    if (standaloneReviewForm && !standaloneReviewForm.getAttribute('data-corp-prep-bound')) {
      standaloneReviewForm.setAttribute('data-corp-prep-bound', 'true');
      standaloneReviewForm.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (typeof standaloneReviewForm.checkValidity === 'function' && !standaloneReviewForm.checkValidity()) {
          if (typeof standaloneReviewForm.reportValidity === 'function') {
            standaloneReviewForm.reportValidity();
          }
          return;
        }

        var compInp = standaloneReviewForm.querySelector('input[name="contact[Company]"]');
        var bInp = standaloneReviewForm.querySelector('textarea[name="contact[body]"]');
        var companyVal = compInp ? compInp.value.trim() : '';
        var rawBody = bInp ? bInp.value.trim() : '';
        var enrichedBody = rawBody;
        if (false && companyVal && rawBody.indexOf('[Corporate:') === -1) {
          enrichedBody = rawBody + '\n\n[Corporate: Company: ' + companyVal + ']';
          if (bInp) bInp.value = enrichedBody;
        }

        var sRatingInput = standaloneReviewForm.querySelector('input[name="contact[Rating]"]:checked');
        var sRating = sRatingInput ? parseInt(sRatingInput.value, 10) : 5;
        var sTitle = (standaloneReviewForm.querySelector('input[name="contact[Review title]"]') || {}).value || '';
        var sName = (standaloneReviewForm.querySelector('input[name="contact[name]"]') || {}).value || '';
        var sEmail = (standaloneReviewForm.querySelector('input[name="contact[email]"]') || {}).value || '';
        var sPhotoInp = standaloneReviewForm.querySelector('[data-corp-photo-input]');
        var sPhotoFiles = (sPhotoInp && sPhotoInp._corpFiles && sPhotoInp._corpFiles.length)
          ? sPhotoInp._corpFiles
          : (sPhotoInp && sPhotoInp.files && sPhotoInp.files.length ? Array.prototype.slice.call(sPhotoInp.files) : []);
        var sProdId = standaloneReviewForm.getAttribute('data-product-id')
          || (standaloneReviewForm.querySelector('input[name="product_id"]') ? standaloneReviewForm.querySelector('input[name="product_id"]').value : '')
          || (window._corpProductInfo && window._corpProductInfo.id) || '';
        var sProdHandle = (window._corpProductInfo && window._corpProductInfo.handle)
          || (standaloneReviewForm.getAttribute('data-product-handle') || '')
          || (new URLSearchParams(window.location.search).get('product') || '');
        var sDomain = standaloneReviewForm.getAttribute('data-shop-domain')
          || (window._corpProductInfo && window._corpProductInfo.shopDomain) || 'ny1yrb-gd.myshopify.com';

        // Show success state on standalone page
        var sSuccess = standaloneReviewForm.querySelector('[data-corp-modal-success]');
        var sSubmitBtn = standaloneReviewForm.querySelector('button[type="submit"]');
        if (sSuccess) sSuccess.style.display = 'block';
        if (sSubmitBtn) sSubmitBtn.disabled = true;

        // Forward review to Judge.me
        var sFormattedName = companyVal ? (sName + ' - ' + companyVal) : sName;
        compressImageFiles(sPhotoFiles, function (cPhotos) {
          forwardReviewToJudgeMe(sRating, sTitle, rawBody, sFormattedName, sEmail, cPhotos, sProdId, sDomain);

          // Keep the submitted review locally so the corporate carousel can show it
          // right after the redirect, before Judge.me publishes it on the storefront.
          readFilesAsDataUrls(cPhotos, function (sDataUrls) {
            saveLocalReview(sProdId, sProdHandle, {
              title: sTitle,
              body: rawBody,
              name: sName,
              author: sName,
              company: companyVal,
              rating: sRating,
              date: new Date().toISOString(),
              photos: sDataUrls,
              verified: true,
              corporate: true,
              source: 'custom-local'
            });
          });
        });

        // Background backup submission
        try {
          var sFormData = new FormData(standaloneReviewForm);
          fetch(standaloneReviewForm.getAttribute('action') || '/contact', {
            method: 'POST',
            body: sFormData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          }).catch(function () { });
        } catch (e) { }

        // Smooth redirect back to corporate product view after 2.2s
        var retInput = standaloneReviewForm.querySelector('input[name="return_to"]');
        var targetUrl = (retInput && retInput.value) ? retInput.value : ('/products/' + sProdId + '?view=corporate#corporate-reviews');
        setTimeout(function () {
          window.location.href = targetUrl;
        }, 2200);
      });
    }
  }

  /* ----------------------------------------------------------------------
     Dynamic Judge.me Reviews Ingestion:
     Extracts real reviews & photos from Judge.me widget and populates
     the bespoke Review Carousel & Buyer Photos gallery dynamically.
     ---------------------------------------------------------------------- */

  function initDynamicReviews(root) {
    if (!root || root.getAttribute('data-corp-dyn-bound') === 'true') return;
    root.setAttribute('data-corp-dyn-bound', 'true');

    try { if (window.jdgm && typeof window.jdgm.initializeWidgets === 'function') { window.jdgm.initializeWidgets(); } else if (window.jdgm && typeof window.jdgm.loadWidgets === 'function') { window.jdgm.loadWidgets(); } } catch (eInit) { } var syncContainer = root.querySelector('[data-corp-jdgm-sync]');
    var populatedEl = root.querySelector('[data-corp-reviews-populated]');
    var emptyEl = root.querySelector('[data-corp-reviews-empty]');

    var prodId = (window._corpProductInfo && window._corpProductInfo.id)
      || (syncContainer ? syncContainer.getAttribute('data-id') : '')
      || (root.getAttribute('data-product-id'))
      || (root.querySelector('[data-product-id]') ? root.querySelector('[data-product-id]').getAttribute('data-product-id') : '')
      || 'default';

    var parseAndPopulate = function () {
      var track = root.querySelector('.corp-review-track[data-corp-reviews]');
      var photosWrap = root.querySelector('.corp-buyer-photos[data-corp-buyer-photos]');
      var photosRow = root.querySelector('.corp-buyer-photos__row');
      var scoreEl = root.querySelector('[data-corp-review-score]');
      var starsEl = root.querySelector('[data-corp-review-stars]');
      var summaryEl = root.querySelector('[data-corp-review-summary]');

      var localReviews = [];
      try {
        var currentHandle = (window._corpProductInfo && window._corpProductInfo.handle) || '';
        localReviews = getLocalReviews(prodId, currentHandle);
      } catch (e) { }

      var jdgmReviews = syncContainer ? Array.prototype.slice.call(syncContainer.querySelectorAll('.jdgm-rev')) : [];
      if (!jdgmReviews.length) {
        var otherWidgets = document.querySelectorAll('#judgeme_product_reviews .jdgm-rev, .corp-jdgm-bridge-wrap .jdgm-rev, .jdgm-widget .jdgm-rev, #tab_review .jdgm-rev, .jdgm-rev');
        if (otherWidgets.length) {
          jdgmReviews = Array.prototype.slice.call(otherWidgets);
        }
      }
      if (!jdgmReviews.length && window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget && (window.jdgm.data.reviewWidget[prodId] || window.jdgm.data.reviewWidget[String(prodId)] || window.jdgm.data.reviewWidget[Number(prodId)])) {
        try {
          var tDiv = document.createElement('div');
          tDiv.innerHTML = window.jdgm.data.reviewWidget[prodId] || window.jdgm.data.reviewWidget[String(prodId)] || window.jdgm.data.reviewWidget[Number(prodId)];
          var wRevs = tDiv.querySelectorAll('.jdgm-rev');
          if (wRevs.length) {
            jdgmReviews = Array.prototype.slice.call(wRevs);
          }
        } catch (eW) { }
      }

      if (!jdgmReviews.length && root._corpJdgmApiReviews && root._corpJdgmApiReviews.length) {
        jdgmReviews = root._corpJdgmApiReviews;
      }

      // If no Judge.me reviews exist on the product in the DOM yet:
      if (!jdgmReviews.length) {
        // Fallback data source: Judge.me widget API. The hidden review widget
        // stays empty whenever Judge.me has not rendered it (or its cache is
        // stale), so request the published reviews directly.
        if (!root._corpJdgmApiFetched && prodId && prodId !== 'default') {
          root._corpJdgmApiFetched = true;

          var apiToken = (window._corpProductInfo && window._corpProductInfo.jdgmPrivateToken) || 'qVz4orw4q0zOy2U4ABi4DwZNC4c';
          var domainCandidates = [
            (window.Shopify && window.Shopify.shop) || '',
            (window._corpProductInfo && window._corpProductInfo.shopDomain) || '',
            (window._corpProductInfo && window._corpProductInfo.altShopDomain) || '', 'ny1yrb-gd.myshopify.com', 'giheritage.com'
          ];
          var apiDomains = [];
          domainCandidates.forEach(function (candidate) {
            var cleanDomain = String(candidate || '').replace(/^https?:\/\//, '').replace(/\/$/, '').trim();
            if (cleanDomain && apiDomains.indexOf(cleanDomain) === -1) apiDomains.push(cleanDomain);
          });

          var buildReviewNodeFromJson = function (review) {
            var node = document.createElement('div');
            node.className = 'jdgm-rev';

            var rating = document.createElement('div');
            rating.className = 'jdgm-rev__rating';
            rating.setAttribute('data-score', String(review.rating || review.score || 5));
            node.appendChild(rating);

            var title = document.createElement('div');
            title.className = 'jdgm-rev__title';
            title.textContent = review.title || review.review_title || '';
            node.appendChild(title);

            var body = document.createElement('div');
            body.className = 'jdgm-rev__body';
            body.textContent = review.body || review.review_body || review.message || '';
            node.appendChild(body);

            var author = document.createElement('div');
            author.className = 'jdgm-rev__author';
            author.textContent = (review.reviewer && review.reviewer.name) || review.name || review.reviewer_name || review.author || 'Corporate Buyer';
            node.appendChild(author);

            var timestamp = document.createElement('div');
            timestamp.className = 'jdgm-rev__timestamp';
            var createdAt = review.created_at || review.created_at_iso || review.timestamp;
            timestamp.textContent = createdAt
              ? new Date(createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
              : 'Recent order';
            node.appendChild(timestamp);

            var isVerified = review.verified !== false && review.verified !== 'false' && review.verified !== 'unverified';
            if (isVerified) {
              var buyerBadge = document.createElement('span');
              buyerBadge.className = 'jdgm-rev__buyer-badge';
              buyerBadge.textContent = 'Verified Buyer';
              node.appendChild(buyerBadge);
              node.setAttribute('data-verified', 'true');
            }

            (Array.isArray(review.pictures) ? review.pictures : []).forEach(function (picture) {
              var url = (picture && ((picture.urls && (picture.urls.original || picture.urls.standard || picture.urls.thumb)) || picture.url || picture.src)) || '';
              if (!url) return;
              var link = document.createElement('a');
              link.className = 'jdgm-rev__pic-link';
              link.href = url;
              var img = document.createElement('img');
              img.className = 'jdgm-rev__pic-img';
              img.src = url;
              img.alt = '';
              link.appendChild(img);
              node.appendChild(link);
            });

            return node;
          };

          var useApiReviews = function (nodes) {
            if (!nodes || !nodes.length) return false;
            root._corpJdgmApiReviews = nodes; if (syncContainer && !syncContainer.querySelectorAll('.jdgm-rev').length) { nodes.forEach(function (node) { try { syncContainer.appendChild(node.cloneNode(true)); } catch (eCl) { } }); }
            parseAndPopulate();
            return true;
          };

          var fetchReviewsForDomain = function (index) {
            if (!apiToken || index >= apiDomains.length) return;
            var cacheUrl = 'https://cache.judge.me/widgets/shopify/' + encodeURIComponent(apiDomains[index]) + '?api_token=' + encodeURIComponent(apiToken) + '&public_token=' + encodeURIComponent(apiToken) + '&review_widget_product_ids=' + encodeURIComponent(prodId); var apiUrl = 'https://api.judge.me/api/v1/reviews'
              + '?shop_domain=' + encodeURIComponent(apiDomains[index])
              + '&api_token=' + encodeURIComponent(apiToken)
              + '&product_id=' + encodeURIComponent(prodId) + '&external_id=' + encodeURIComponent(prodId)
              + '&per_page=20';

            fetch(cacheUrl).then(function (r) { return r.ok ? r.json() : null; }).then(function (cData) { if (cData && (cData.review_widgets || cData.review_widget || cData.widgets || cData.widget || cData.reviews || Array.isArray(cData))) return cData; return fetch(apiUrl, { headers: { 'Accept': 'application/json' } }).then(function (r2) { return r2.ok ? r2.json() : null; }); })
              .then(function (res) { return res.ok ? res.json() : null; })
              .then(function (data) {
                var wMap = data && (data.review_widgets || data.review_widget || data.widgets || data.widget); var widgetHtml = (typeof wMap === 'string') ? wMap : (wMap && (wMap[prodId] || wMap[String(prodId)] || wMap[Number(prodId)] || (Object.keys(wMap).length ? wMap[Object.keys(wMap)[0]] : null))); if (!widgetHtml && data && typeof data.widget === 'string') widgetHtml = data.widget;
                if (typeof widgetHtml === 'string' && widgetHtml) {
                  var holder = document.createElement('div');
                  holder.innerHTML = widgetHtml;
                  var widgetReviews = Array.prototype.slice.call(holder.querySelectorAll('.jdgm-rev'));
                  if (useApiReviews(widgetReviews)) return;
                }
                var rawList = Array.isArray(data) ? data : (data && Array.isArray(data.reviews) ? data.reviews : []); if (rawList.length && useApiReviews(rawList.map(buildReviewNodeFromJson))) return; if (false) {

                }
                fetchReviewsForDomain(index + 1);
              })
              .catch(function () { fetchReviewsForDomain(index + 1); });
          };

          fetchReviewsForDomain(0);
        }

        var hasMerchantBlocks = track && track.querySelectorAll('.corp-review-card:not([data-corp-jdgm-review])').length > 0;
        var liquidHasRealReviews = !!(summaryEl && summaryEl.textContent && summaryEl.textContent.indexOf('Based on') !== -1 && summaryEl.textContent.indexOf('0 review') === -1); if (!hasMerchantBlocks && localReviews.length === 0 && !liquidHasRealReviews) {
          if (emptyEl) emptyEl.style.display = '';
          if (populatedEl) populatedEl.style.display = 'none';
          if (photosRow && !photosRow.querySelectorAll('[data-merchant-block]').length) {
            if (photosWrap) photosWrap.style.display = 'none';
          }
          return;
        }

        if (emptyEl) emptyEl.style.display = 'none';
        if (populatedEl) populatedEl.style.display = ''; if (liquidHasRealReviews && emptyEl) emptyEl.style.display = 'none';
      }

      // We have real Judge.me or local reviews! Reveal populated container, hide empty container
      if (emptyEl) emptyEl.style.display = 'none';
      if (populatedEl) populatedEl.style.display = '';

      if (track) {
        var slides = [];
        var allPhotoUrls = [];
        var seenReviewSignatures = {};

        // Parse and add Judge.me reviews
        jdgmReviews.forEach(function (rev) {
          var ratingScore = 5;
          var ratingAttr = rev.querySelector('.jdgm-rev__rating');
          if (ratingAttr && ratingAttr.getAttribute('data-score')) {
            ratingScore = parseInt(ratingAttr.getAttribute('data-score'), 10) || 5;
          } else {
            var onStars = rev.querySelectorAll('.jdgm-star.jdgm--on');
            if (onStars.length) ratingScore = onStars.length;
          }

          var timeEl = rev.querySelector('.jdgm-rev__timestamp');
          var timeText = timeEl ? timeEl.textContent.trim() : 'Recent order';

          var titleEl = rev.querySelector('.jdgm-rev__title');
          var titleText = titleEl ? titleEl.textContent.trim() : 'Verified GI Heritage Purchase';

          var bodyEl = rev.querySelector('.jdgm-rev__body');
          var bodyText = bodyEl ? bodyEl.textContent.trim() : '';

          var authorEl = rev.querySelector('.jdgm-rev__author');
          var authorText = authorEl ? authorEl.textContent.trim() : 'Corporate Buyer';
          var authorName = authorText;
          var companyFromAuthor = '';

          // Parse company name appended to reviewer name: "Name - Company" or "Name · Company"
          if (authorText.indexOf(' - ') !== -1) {
            var aParts = authorText.split(' - ');
            authorName = aParts[0].trim();
            companyFromAuthor = aParts.slice(1).join(' - ').trim();
          } else if (authorText.indexOf(' · ') !== -1) {
            var aParts = authorText.split(' · ');
            authorName = aParts[0].trim();
            companyFromAuthor = aParts.slice(1).join(' · ').trim();
          }

          var isBuyer = rev.hasAttribute('data-verified')
            ? (rev.getAttribute('data-verified') !== 'false')
            : (!!rev.querySelector('.jdgm-rev__buyer-badge, .jdgm-buyer-badge, .jdgm--verified-buyer') || !rev.querySelector('.jdgm-rev__buyer-badge--false, .jdgm--unverified'));

          var parsedCompany = '';
          var parsedQty = '';
          var parsedOccasion = '';

          var corpMatch = bodyText.match(/\[Corporate:\s*([^\]]+)\]/i);
          if (corpMatch && corpMatch[1]) {
            var metaContent = corpMatch[1];
            bodyText = bodyText.replace(/\[Corporate:\s*[^\]]+\]/gi, '').trim();

            var segments = metaContent.split('|');
            segments.forEach(function (seg) {
              var s = seg.trim();
              if (/^Company:\s*/i.test(s)) {
                parsedCompany = s.replace(/^Company:\s*/i, '').trim();
              } else if (/^Qty:\s*/i.test(s)) {
                parsedQty = s.replace(/^Qty:\s*/i, '').trim();
              } else if (/^Occasion:\s*/i.test(s)) {
                parsedOccasion = s.replace(/^Occasion:\s*/i, '').trim();
              }
            });
          }

          if (!parsedCompany && companyFromAuthor) {
            parsedCompany = companyFromAuthor;
          }

          var picImgs = Array.prototype.slice.call(rev.querySelectorAll('.jdgm-rev__pic-link img, .jdgm-rev__pic-img'));
          var picUrls = picImgs.map(function (img) {
            var src = img.getAttribute('data-src') || img.getAttribute('src') || '';
            if (src.indexOf('http') === 0) return src;
            var link = img.closest ? img.closest('a') : null;
            var linkHref = link ? (link.getAttribute('href') || '') : '';
            return linkHref.indexOf('http') === 0 ? linkHref : '';
          }).filter(Boolean);

          // Fallback: some widget versions render the picture as a link without an <img>
          if (!picUrls.length) {
            var picLinks = Array.prototype.slice.call(rev.querySelectorAll('a.jdgm-rev__pic-link[href]'));
            picUrls = picLinks.map(function (link) {
              var href = link.getAttribute('href') || '';
              return href.indexOf('http') === 0 ? href : '';
            }).filter(Boolean);
          }
          picUrls = picUrls.filter(function (url, idx) { return picUrls.indexOf(url) === idx; });

          picUrls.forEach(function (url) {
            if (allPhotoUrls.indexOf(url) === -1) allPhotoUrls.push(url);
          });

          var sig = getReviewSig(titleText, bodyText, authorName);
          seenReviewSignatures[sig] = true;

          var slide = buildReviewCardDOM({
            rating: ratingScore,
            title: titleText,
            body: bodyText,
            name: authorName,
            company: parsedCompany,
            date: timeText,
            photos: picUrls,
            verified: isBuyer
          }, false); slide.setAttribute('data-corp-jdgm-review', 'true');

          slides.push(slide);
        });

        // Add local reviews that have not yet appeared in Judge.me
        if (localReviews.length) {
          localReviews.forEach(function (review) {
            var sig = getReviewSig(review.title, review.body, review.author || review.name);
            if (!seenReviewSignatures[sig]) {
              seenReviewSignatures[sig] = true;
              var localPhotos = Array.isArray(review.photos) ? review.photos : [];
              localPhotos.forEach(function (url) {
                if (allPhotoUrls.indexOf(url) === -1) allPhotoUrls.push(url);
              });
              var slide = buildReviewCardDOM({
                rating: review.rating || 5,
                title: review.title || 'Verified GI Heritage Purchase',
                body: review.body || '',
                name: review.author || review.name || 'Corporate Buyer',
                company: review.company || '',
                date: review.date ? new Date(review.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'Recent order',
                photos: localPhotos,
                verified: review.verified !== false
              }, false); slide.setAttribute('data-corp-jdgm-review', 'true');
              slide.setAttribute('data-corp-local-review', 'true');
              slides.unshift(slide);
            }
          });
        }

        // Auto-prune localStorage: Once Judge.me returns the published review, remove local copy
        if (localReviews.length && jdgmReviews.length) {
          var unpruned = localReviews.filter(function (review) {
            var sig = getReviewSig(review.title, review.body, review.author || review.name);
            return !seenReviewSignatures[sig];
          });
          if (unpruned.length !== localReviews.length) {
            try {
              localStorage.setItem('corp_user_reviews_' + prodId, JSON.stringify(unpruned));
            } catch (ePrune) { }
          }
        }

        if (slides.length > 0) {
          track.innerHTML = ''; console.log('[Corporate Reviews] Rendered ' + slides.length + ' review card(s) into track.');
          slides.forEach(function (s) { track.appendChild(s); });

          var slider = track.closest('[data-corp-slider]');
          if (slider) {
            slider.removeAttribute('data-slider-ready');
            initFeaturedSlider(slider.parentElement || root);
          }
          initReviewFilters(root); if (emptyEl) emptyEl.style.display = 'none'; if (populatedEl) populatedEl.style.display = ''; } else if (!hasMerchantBlocks) { if (emptyEl) emptyEl.style.display = ''; if (populatedEl) populatedEl.style.display = 'none';
        }

        // Update score & summary
        var totalReviewsCount = slides.length;
        var displayCount = totalReviewsCount;
        if (syncContainer) {
          var countEl = syncContainer.querySelector('.jdgm-rev-widg__summary-text');
          if (countEl) {
            var countMatch = countEl.textContent.match(/(\d+)/);
            if (countMatch) {
              var parsedCount = parseInt(countMatch[1], 10);
              if (parsedCount > 0) displayCount = parsedCount;
            }
          }
        }
        if (totalReviewsCount > 0) {
          var avg = 5.0;
          if (syncContainer) {
            var avgEl = syncContainer.querySelector('.jdgm-rev-widg__summary-average');
            if (avgEl && parseFloat(avgEl.textContent.trim())) {
              avg = parseFloat(avgEl.textContent.trim());
            }
          }
          if (scoreEl) scoreEl.textContent = avg.toFixed(1);
          if (starsEl) {
            var starStr = '';
            var rounded = Math.round(avg);
            for (var s = 1; s <= 5; s++) starStr += (s <= rounded ? '★' : '☆');
            starsEl.textContent = starStr;
          }
          if (summaryEl) {
            summaryEl.textContent = 'Based on ' + displayCount + ' ' + (displayCount === 1 ? 'review' : 'reviews');
          }
        }

        // Photos gallery
        if (photosRow && allPhotoUrls.length > 0) {
          if (photosWrap) photosWrap.style.display = '';
          // Only clear dynamic photos injected by this script; editor-picked photos stay
          Array.prototype.slice.call(photosRow.querySelectorAll('.corp-buyer-photo--jdgm, .corp-buyer-photo--local')).forEach(function (node) {
            node.remove();
          });
          allPhotoUrls.slice(0, 5).forEach(function (url) {
            var photoSpan = document.createElement('span');
            photoSpan.className = 'corp-buyer-photo corp-buyer-photo--jdgm';
            var pImg = document.createElement('img');
            pImg.src = url;
            pImg.alt = 'Verified corporate buyer photo';
            pImg.loading = 'lazy';
            photoSpan.appendChild(pImg);
            photosRow.appendChild(photoSpan);
          });
          if (allPhotoUrls.length > 5) {
            var moreSpan = document.createElement('span');
            moreSpan.className = 'corp-buyer-photo corp-buyer-photo--more corp-buyer-photo--jdgm';
            moreSpan.textContent = '+' + (allPhotoUrls.length - 5);
            photosRow.appendChild(moreSpan);
          }
        }
      }
    };

    parseAndPopulate();

    if (syncContainer && window.MutationObserver) {
      var pending = null;
      var observer = new MutationObserver(function (mutations) {
        var hasAdded = mutations.some(function (m) { return m.addedNodes && m.addedNodes.length > 0; });
        if (!hasAdded || pending) return;
        pending = setTimeout(function () {
          pending = null;
          parseAndPopulate();
        }, 200);
      });
      var allJdgTargets = document.querySelectorAll('#judgeme_product_reviews, [data-corp-jdgm-sync], .jdgm-review-widget'); allJdgTargets.forEach(function (tgt) { try { observer.observe(tgt, { childList: true, subtree: true }); } catch (eObs) { } });
    }

    document.addEventListener('jdgm.widgetLoaded', function () {
      setTimeout(parseAndPopulate, 100);
    });
    var pollCount = 0; var pollTimer = setInterval(function () { pollCount++; var foundReviews = (syncContainer && syncContainer.querySelectorAll('.jdgm-rev').length > 0) || document.querySelectorAll('#judgeme_product_reviews .jdgm-rev, .jdgm-rev').length > 0; if (foundReviews || pollCount >= 40) { if (foundReviews) parseAndPopulate(); if (pollCount >= 40) clearInterval(pollTimer); } }, 250); document.addEventListener('jdgm.doneLoading', function () {
      setTimeout(parseAndPopulate, 100);
    });

    window.addEventListener('load', function () {
      try { if (window.jdgm && typeof window.jdgm.initializeWidgets === 'function') { window.jdgm.initializeWidgets(); } else if (window.jdgm && typeof window.jdgm.loadWidgets === 'function') { window.jdgm.loadWidgets(); } } catch (eL) { } setTimeout(parseAndPopulate, 400);
      setTimeout(parseAndPopulate, 1200);
      setTimeout(parseAndPopulate, 2500);
      setTimeout(parseAndPopulate, 4500);
    });
  }

  /* ----------------------------------------------------------------------
     Product Cards: Open product details page on card click
     ---------------------------------------------------------------------- */

  function initProductCards(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('.corp-product[data-url]'));
    cards.forEach(function (card) {
      if (card.getAttribute('data-card-bound') === 'true') return;
      card.setAttribute('data-card-bound', 'true');

      card.addEventListener('click', function (e) {
        if (e.target.closest('a, button, [data-corp-quote-btn], [data-corp-quote-trigger], [data-corp-modal-open], input, select, textarea, label')) return;
        var clickedLink = e.target.closest('a');
        if (clickedLink && clickedLink.getAttribute('href') && clickedLink.getAttribute('href') !== '#') {
          return;
        }
        var url = card.getAttribute('data-url');
        if (url && url !== '#') {
          window.location.href = url;
        }
      });

      card.addEventListener('keydown', function (e) {
        if (e.target.closest('a, button, [data-corp-quote-btn], [data-corp-quote-trigger]')) return;
        if (e.key === 'Enter' || e.keyCode === 13) {
          var url = card.getAttribute('data-url');
          if (url && url !== '#') {
            window.location.href = url;
          }
        }
      });
    });
  }

  /* ----------------------------------------------------------------------
     Buyer Review Photos Lightbox
     Enlarges clicked buyer photos or review card thumbnails into a modal preview
     ---------------------------------------------------------------------- */

  function initReviewPhotoLightbox() {
    if (window._corpLightboxInitialized) return;
    window._corpLightboxInitialized = true;

    var getLightbox = function () {
      return document.getElementById('corp-image-lightbox');
    };

    // Ensure lightbox is closed on initial page load / reload
    var initialLightbox = getLightbox();
    if (initialLightbox) {
      initialLightbox.classList.remove('is-open');
      initialLightbox.style.display = 'none';
      initialLightbox.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('corp-modal-open');

    var openLightbox = function (imgSrc, altText) {
      var lightbox = getLightbox();
      if (!lightbox || !imgSrc) return;
      var lightboxImg = lightbox.querySelector('.corp-lightbox__img');
      var lightboxCaption = lightbox.querySelector('.corp-lightbox__caption');

      if (lightboxImg) lightboxImg.src = imgSrc;
      if (altText && lightboxCaption) {
        lightboxCaption.textContent = altText;
        lightboxCaption.style.display = 'block';
      } else if (lightboxCaption) {
        lightboxCaption.textContent = '';
        lightboxCaption.style.display = 'none';
      }

      lightbox.classList.add('is-open');
      lightbox.style.display = 'flex';
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('corp-modal-open');
    };

    var closeLightbox = function () {
      var lightbox = getLightbox();
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      lightbox.style.display = 'none';
      var lightboxImg = lightbox.querySelector('.corp-lightbox__img');
      if (lightboxImg) lightboxImg.src = '';
      document.body.classList.remove('corp-modal-open');
    };

    // Global delegated click listener strictly for customer uploaded review photos
    document.addEventListener('click', function (e) {
      // Close button or backdrop
      if (e.target.closest('[data-corp-lightbox-close]') || e.target.classList.contains('corp-lightbox__backdrop') || e.target.classList.contains('corp-lightbox__close')) {
        e.preventDefault();
        closeLightbox();
        return;
      }

      // Strictly limit to reviews section to prevent any PDP hero gallery or quote modal images from triggering
      var reviewsSection = e.target.closest('.corp-reviews');
      if (!reviewsSection) return;

      var buyerPhoto = e.target.closest('.corp-buyer-photo');
      var cardThumb = e.target.closest('.corp-review-card__thumbs .corp-media, .corp-review-card__thumbs img, .corp-review-card__thumbs a');
      if (!buyerPhoto && !cardThumb) return;

      var photoTarget = buyerPhoto || cardThumb;

      if (photoTarget.classList.contains('corp-buyer-photo--more')) {
        e.preventDefault();
        e.stopPropagation();
        var row = photoTarget.closest('.corp-buyer-photos__row');
        var firstValidImg = row ? row.querySelector('.corp-buyer-photo:not(.corp-buyer-photo--more) img') : null;
        if (firstValidImg) {
          var fSrc = firstValidImg.getAttribute('src') || firstValidImg.getAttribute('data-src') || firstValidImg.src;
          if (fSrc && fSrc !== '#' && fSrc.indexOf('blank.gif') === -1) {
            openLightbox(fSrc, firstValidImg.getAttribute('alt') || 'Verified buyer review photo');
          }
        }
        return;
      }

      var img = photoTarget.tagName === 'IMG' ? photoTarget : photoTarget.querySelector('img');
      if (!img) return;

      var rawSrc = img.getAttribute('src') || img.getAttribute('data-src') || img.src || '';
      if (!rawSrc || rawSrc === '#' || rawSrc.indexOf('blank.gif') !== -1) return;

      e.preventDefault();
      e.stopPropagation();

      var hiresSrc = rawSrc.replace(/_(?:width=)?\d+x\d*/, '').replace(/&width=\d+/, '&width=1200');
      var alt = img.getAttribute('alt') || 'Verified buyer review photo';
      openLightbox(hiresSrc, alt);
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        var lightbox = getLightbox();
        if (lightbox && lightbox.style.display !== 'none' && lightbox.getAttribute('aria-hidden') === 'false') {
          closeLightbox();
        }
      }
    });
  }

  /* ----------------------------------------------------------------------
     Corporate sub-navbar mobile dropdown
     ---------------------------------------------------------------------- */

  function initCorpNav(root) {
    var nav = root.querySelector('[data-corp-nav]') || (root.classList && root.classList.contains('corp-nav') ? root : null) || document.querySelector('[data-corp-nav]');
    if (!nav) return;

    var toggle = nav.querySelector('[data-corp-nav-toggle]');
    var menu = nav.querySelector('[data-corp-nav-menu]');
    if (!toggle || !menu) return;

    if (toggle.getAttribute('data-nav-bound') === 'true') return;
    toggle.setAttribute('data-nav-bound', 'true');

    var openMenu = function () {
      toggle.setAttribute('aria-expanded', 'true');
      nav.classList.add('is-open');
    };

    var closeMenu = function () {
      toggle.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
    };

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (nav.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    document.addEventListener('click', function (e) {
      if (nav.classList.contains('is-open') && !nav.contains(e.target)) {
        closeMenu();
      }
    });

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && nav.classList.contains('is-open')) {
        closeMenu();
      }
    });

    var links = menu.querySelectorAll('a');
    links.forEach(function (link) {
      link.addEventListener('click', function () {
        closeMenu();
      });
    });
  }

  /* ----------------------------------------------------------------------
     PDP Quantity Tier Sync & Dynamic Discount Price Calculation:
     - Automatically calculates discounted tier prices (7.5%, 12.5%, 15% off base price)
     - Ensures zero bracketed placeholders (e.g. "[price]") ever appear
     - Dynamically highlights the active price tier based on quantity entered
     - Syncs active tier unit price with the quote trigger and modal
     ---------------------------------------------------------------------- */

  function formatPriceINR(rupees) {
    var rounded = Math.round(rupees);
    return '₹' + rounded.toLocaleString('en-IN');
  }

  function getBasePriceRupees(container) {
    var tierTable = container ? (container.matches && container.matches('.corp-tier') ? container : container.querySelector('.corp-tier')) : document.querySelector('.corp-tier');
    var rawBase = tierTable ? tierTable.getAttribute('data-base-price') : null;
    var baseCents = rawBase ? parseFloat(rawBase) : 0;
    if (baseCents > 0) {
      return baseCents > 10000 ? (baseCents / 100) : baseCents;
    }

    var quoteBtn = (container || document).querySelector('[data-corp-quote-trigger], [data-product-price]');
    if (quoteBtn && quoteBtn.getAttribute('data-product-price')) {
      var btnPrice = parseFloat(quoteBtn.getAttribute('data-product-price').replace(/[^0-9.]/g, ''));
      if (btnPrice > 0) return btnPrice;
    }

    if (typeof window !== 'undefined' && window._corpProductInfo && window._corpProductInfo.price) {
      var wPrice = parseFloat(window._corpProductInfo.price);
      if (wPrice > 0) return wPrice > 10000 ? (wPrice / 100) : wPrice;
    }

    return 5249;
  }

  function ensureTierPricesCalculated(tierTable) {
    if (!tierTable) return;
    var container = tierTable.closest('.corp-pdp__info') || tierTable.closest('.corp-pdp') || tierTable.parentElement || document;
    var baseRupees = getBasePriceRupees(container);
    var rows = Array.prototype.slice.call(tierTable.querySelectorAll('[data-corp-tier-row]'));

    rows.forEach(function (row, idx) {
      var minVal = parseInt(row.getAttribute('data-tier-min'), 10);
      var discountAttr = row.getAttribute('data-tier-discount');
      var discount = discountAttr ? parseFloat(discountAttr) : 0;

      if (isNaN(discount) || discount <= 0) {
        if (minVal >= 500) discount = 15;
        else if (minVal >= 100) discount = 12.5;
        else if (idx === 0) discount = 7.5;
        else if (idx === 1) discount = 12.5;
        else if (idx === 2) discount = 15;
        else discount = 15;
        row.setAttribute('data-tier-discount', String(discount));
      }

      var priceEl = row.querySelector('[data-corp-tier-price]') || row.querySelector('strong');
      var currentText = priceEl ? priceEl.textContent.trim() : '';
      var rowAttrPrice = row.getAttribute('data-tier-price') || '';

      var isPlaceholder = !currentText
        || currentText.indexOf('[') !== -1
        || currentText.indexOf(']') !== -1
        || currentText.toLowerCase().indexOf('price') !== -1
        || currentText.indexOf('NaN') !== -1
        || currentText.indexOf('<') !== -1
        || currentText.indexOf('span') !== -1
        || currentText.indexOf('money') !== -1
        || rowAttrPrice.indexOf('[') !== -1
        || rowAttrPrice.indexOf('<') !== -1
        || rowAttrPrice.indexOf('&lt;') !== -1
        || rowAttrPrice.toLowerCase().indexOf('price') !== -1;

      if (isPlaceholder || !rowAttrPrice || rowAttrPrice.indexOf('[') !== -1) {
        var discountedRupees = Math.round(baseRupees * (1 - (discount / 100)));
        var formatted = formatPriceINR(discountedRupees);
        if (priceEl) priceEl.textContent = formatted;
        row.setAttribute('data-tier-price', formatted);
      }
    });
  }

  function initTierQuantitySync(root) {
    if (!root) return;

    var tierTables = Array.prototype.slice.call(root.querySelectorAll('.corp-tier'));
    if (root.classList && root.classList.contains('corp-tier')) {
      tierTables.push(root);
    }
    tierTables.forEach(function (table) {
      ensureTierPricesCalculated(table);
    });

    var qtyInputs = Array.prototype.slice.call(root.querySelectorAll('[data-corp-pdp-qty]'));
    if (!qtyInputs.length) return;

    qtyInputs.forEach(function (input) {
      if (input.getAttribute('data-tier-sync-bound') === 'true') return;
      input.setAttribute('data-tier-sync-bound', 'true');

      var container = input.closest('.corp-pdp__info') || input.closest('.corp-pdp') || document;
      var tierRows = Array.prototype.slice.call(container.querySelectorAll('[data-corp-tier-row]'));
      var quoteBtn = container.querySelector('[data-corp-quote-trigger]');

      var syncTier = function () {
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty <= 0) qty = 1;

        if (tierRows.length) {
          var matchedIndex = 0;
          for (var i = 0; i < tierRows.length; i++) {
            var minVal = parseInt(tierRows[i].getAttribute('data-tier-min'), 10) || 0;
            if (qty >= minVal) {
              matchedIndex = i;
            }
          }

          var activeRow = tierRows[matchedIndex] || tierRows[0];
          var rawPriceVal = activeRow.getAttribute('data-tier-price') || (activeRow.querySelector('[data-corp-tier-price]') ? activeRow.querySelector('[data-corp-tier-price]').textContent.trim() : '');
          var priceVal = cleanPriceText(rawPriceVal);
          if (quoteBtn && priceVal) {
            quoteBtn.setAttribute('data-product-price', priceVal);
          }
        }
      };

      input.addEventListener('input', syncTier);
      input.addEventListener('change', syncTier);
      syncTier();
    });
  }

  onReady(function () {
    initModals(document);
    initCorpNav(document);
    initReviewPhotoLightbox();
    Array.prototype.slice.call(document.querySelectorAll('.corp')).forEach(function (root) {
      initCorpNav(root);
      initCatalog(root);
      initFeaturedSlider(root);
      initProductCards(root);
      initGallery(root);
      initTierQuantitySync(root);
      initReviewFilters(root);
      initRating(root);
      initPhotoPicker(root);
      initQuoteExtras(root);
      initProductParam(root);
      initJudgeMe(root);
      initDynamicReviews(root);
      initModals(root);
    });
  });

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target;
    if (target) {
      initCorpNav(target);
      initCatalog(target);
      initFeaturedSlider(target);
      initProductCards(target);
      initGallery(target);
      initTierQuantitySync(target);
      initJudgeMe(target);
      initDynamicReviews(target);
      initModals(target);
      initReviewPhotoLightbox();
    }
  });
})();
